<template>
  <!-- 运费订单 -->
  <div class="billOperationRecord public_Spacing">
    <div class="pulbic_oparetionBlock dispatch-filter-card" style="margin-bottom: 1px;">
      <div class="dispatch-section-head">
        <div>
          <h3 class="dispatch-section-title">运费订单筛选</h3>
          <p class="dispatch-section-desc">支持按企业、物料、状态、人员和快捷时间组合筛选，先缩小时间范围会更高效。</p>
        </div>
      </div>
      <div class="public_criteriaRange">
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">企业：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            @change="erpChange"
            v-model="enterpriseTwo"
            placeholder="请选择"
            filterable
            clearable
            remote
            :remote-method="filterEnterprise"
          >
            <el-option
              v-for="item in filteredEnterpriseOptions"
              :key="item.SETTB99ID"
              :label="item.SETTB99CA00"
              :value="item.SETTB99ID"
            >
            </el-option>
          </el-select>
        </div>
      
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">物料：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="materielMo"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in materielOptions"
              :key="item.SETTB109ID"
              :label="item.SETTB109CA00"
              :value="item.SETTB109ID"
            >
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">状态：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="SETTB122CA07"
            placeholder="请选择"
          >
            <el-option
              v-for="item in dataStatusOperation"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty" style="width:7vw;">运费结算方式：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="ORMTB470CA58"
            placeholder="请选择"
          >
            <el-option
              v-for="item in dataStatusOperation0"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">车牌号：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <input
                class="pulic_carNumber"
                type="text"
                placeholder="请输入"
                v-model="carNumber"
              />
            </div>
          </div>
        </div>
       
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">离线订单：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="lxorde"
            placeholder="请选择"
          >
            <el-option
              v-for="item in orlxOrdeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">时间：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="timeType"
            placeholder="请选择"
          >
            <el-option label="接单时间" value="1"> </el-option>
            <el-option label="出厂时间" value="2"> </el-option>
            <el-option label="卸货时间" value="4"> </el-option>
            <el-option label="完成时间" value="3"> </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">修改流水：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="xgorde"
            placeholder="请选择"
          >
            <el-option
              v-for="item in orXgOrdeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="public_oparetionBlock_Menu"
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
        >
          <label class="public_lbSty">接单人：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="ORMTB470CA12"
            placeholder="请选择"
            :clearable="true"
            filterable
            remote
            :remote-method="filterCustomer"
          >
            <el-option
              v-for="item in filteredCustomerOptions"
              :key="item.ORMTB410ID"
              :label="item.ORMTB410CA00"
              :value="item.ORMTB410CA00"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="public_oparetionBlock_Menu"
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
        >
          <label class="public_lbSty" style="width: 7vw;">发单人：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="ORMTB470CA40"
            placeholder="请选择"
            :clearable="true"
            filterable
            remote
            :remote-method="filterCustomer"
          >
            <el-option
              v-for="item in filteredCustomerOptions"
              :key="item.ORMTB410ID"
              :label="item.ORMTB410CA00"
              :value="item.ORMTB410CA00"
            >
            </el-option>
          </el-select>
        </div>
        <div
          class="public_oparetionBlock_Menu"
          v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'"
        >
          <label class="public_lbSty">货主：</label>
          <el-select
            class="public_optionSty dropDown_Define"
            v-model="ORMTB410CA04"
            placeholder="请选择"
            :clearable="true"
            filterable
            remote
            :remote-method="filterCustomer"
          >
            <el-option
              v-for="item in filteredCustomerOptions"
              :key="item.ORMTB410ID"
              :label="item.ORMTB410CA00"
              :value="item.ORMTB410CA00"
            >
            </el-option>
          </el-select>
        </div>
		<div class="public_oparetionBlock_Menu">
		  <label class="public_lbSty">错单：</label>
		  <el-select
		    class="public_optionSty dropDown_Define"
		    v-model="cdorde"
		    placeholder="请选择"
		  >
		    <el-option
		      v-for="item in orCdOrdeOptions"
		      :key="item.value"
		      :label="item.label"
		      :value="item.value"
		    >
		    </el-option>
		  </el-select>
		</div>
      </div>
      <div class="public_operatArea dispatch-date-row">
        <span class="dispatch-date-label">快捷时间</span>
        <span
          class="pulic_operatArea_now pulic_cursor"
          :class="dateNowDayActive ? 'public_dateActive' : ''"
          @click="getNowDay"
          >当日</span
        >
        <span
          class="public_operatArea_yesterday pulic_cursor"
          :class="dateYesterdayActive ? 'public_dateActive' : ''"
          @click="getYesterday"
          >昨天</span
        >
        <span
          class="pulic_operatArea_now pulic_cursor"
          :class="dateNowMonthActive ? 'public_dateActive' : ''"
          @click="sameMonth"
          >当月</span
        >
        <span
          class="public_operatArea_yesterday pulic_cursor"
          :class="dateLastMonthActive ? 'public_dateActive' : ''"
          @click="lastMonth"
          >上月</span
        >
        <div class="public_operatArea_timePicker pulic_cursor">
          <el-date-picker
            v-model="date"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            :picker-options="startDateDisabled"
            @change="datePickerChange"
            start-placeholder="开始日"
            end-placeholder="结束日"
            class="pulic_cursor"
          >
          </el-date-picker>
        </div>
		
		<div class="public_oparetionBlock_Menu">
		  <label class="public_lbSty" style="padding-left: 20px;">订单出处：</label>
		  <el-select class="public_optionSty dropDown_Define" v-model="orderSource" placeholder="请选择">
		    <el-option v-for="item in orderSourceOpenOptions" :key="item.value" :label="item.label" :value="item.value">
		    </el-option>
		  </el-select>
		</div>
		
        <div class="public_operatBtn dispatch-operat-btn">
          <button
            @click="queryClick"
            class="public_saleWater_chaxun pulic_cursor"
            v-shiroHiden="solelist"
            id="查询"
          >
            <i class="iconfont icon-chaxun"></i>查询
          </button>
          <el-button class="dispatch-reset-btn" plain @click="resetFilters">
            <i class="el-icon-refresh-left"></i>重置筛选
          </el-button>
          <el-button
            class="public_saleWater_daochu pulic_cursor"
            :loading="loadingBut"
            @click="exports"
            v-shiroHiden="solelist"
            id="导出"
            ><i class="iconfont icon-daochu"></i>导出<span
              v-if="confirmTxt > 0"
              >{{ confirmTxt }}</span
            ></el-button
          >
          <el-popover ref="popover2" trigger="click">
            <div style="text-align: left;padding-left: 20px;padding-top: 8px;">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkAll"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group
                v-model="checkedCities"
                @change="handleCheckedCitiesChange"
              >
                <el-checkbox
                  style="display: block;"
                  class="salesWater_checkbox"
                  v-for="city in cities"
                  :label="city"
                  :key="city"
                  >{{ city }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
    <div v-shiroHiden="solelist" id="统计" class="dispatch-section-wrap" style="width: 100%;">
      <div class="dispatch-section-head">
        <div>
          <h3 class="dispatch-section-title">运费订单统计</h3>
          <p class="dispatch-section-desc">统计结果随当前筛选条件和时间范围同步刷新，按金额与运输维度分类展示。</p>
        </div>
      </div>
      <div class="freight-stat-shell">
        <div class="freight-stat-hint">
          <span>可悬停查看完整数值</span>
          <span>按金额与运输维度分组展示</span>
        </div>
        <div class="freight-stat-panel">
          <div class="freight-stat-group freight-stat-group-money">
          <div class="freight-stat-group-title">
            <span>金额指标</span>
            <em>物料金额与运费金额</em>
          </div>
          <div class="freight-stat-grid">
            <div class="freight-stat-card freight-stat-card-money">
              <div class="freight-stat-card-head">
                <div class="freight-stat-icon">
                  <img src="../../assets/images/orderStatistics/money.png" />
                </div>
                <div>
                  <p class="freight-stat-title">物料金额</p>
                  <p class="freight-stat-desc">接单 / 出厂 / 卸货</p>
                </div>
              </div>
              <el-tooltip :content="String(pdje)" placement="top">
                <div class="freight-stat-main">
                  <span>接单金额(元)</span>
                  <strong>{{ pdje }}</strong>
                </div>
              </el-tooltip>
              <div class="freight-stat-subgrid">
                <el-tooltip :content="String(jsje)" placement="top">
                  <div>
                    <span>出厂金额(元)</span>
                    <strong>{{ jsje }}</strong>
                  </div>
                </el-tooltip>
                <el-tooltip :content="String(wcje)" placement="top">
                  <div>
                    <span>完成金额(元)</span>
                    <strong>{{ wcje }}</strong>
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div class="freight-stat-card freight-stat-card-freight">
              <div class="freight-stat-card-head">
                <div class="freight-stat-icon">
                  <img src="../../assets/images/orderStatistics/money.png" />
                </div>
                <div>
                  <p class="freight-stat-title">运费金额</p>
                  <p class="freight-stat-desc">接单 / 出厂 / 扣除 / 结算</p>
                </div>
              </div>
              <el-tooltip :content="String(pdyf)" placement="top">
                <div class="freight-stat-main">
                  <span>接单运费(元)</span>
                  <strong>{{ pdyf }}</strong>
                </div>
              </el-tooltip>
              <div class="freight-stat-subgrid freight-stat-subgrid-compact">
                <el-tooltip :content="String(jsyf)" placement="top">
                  <div>
                    <span>出厂运费(元)</span>
                    <strong>{{ jsyf }}</strong>
                  </div>
                </el-tooltip>
                <el-tooltip :content="String(wcyf)" placement="top">
                  <div>
                    <span>扣除运费(元)</span>
                    <strong>{{ wcyf }}</strong>
                  </div>
                </el-tooltip>
                <el-tooltip :content="String(jsyfsjtj)" placement="top">
                  <div>
                    <span>结算运费(元)</span>
                    <strong>{{ jsyfsjtj }}</strong>
                  </div>
                </el-tooltip>
                <el-tooltip :content="String(glf)" placement="top" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
                  <div>
                    <span>管理费(元)</span>
                    <strong>{{ glf }}</strong>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
        <div class="freight-stat-group freight-stat-group-operate">
          <div class="freight-stat-group-title">
            <span>运输指标</span>
            <em>车次与重量</em>
          </div>
          <div class="freight-stat-grid">
            <div class="freight-stat-card freight-stat-card-count">
              <div class="freight-stat-card-head">
                <div class="freight-stat-icon">
                  <img src="../../assets/images/orderStatistics/trainNumber.png" />
                </div>
                <div>
                  <p class="freight-stat-title">车次</p>
                  <p class="freight-stat-desc">接单 / 出厂 / 卸货</p>
                </div>
              </div>
              <el-tooltip :content="String(pdcc)" placement="top">
                <div class="freight-stat-main">
                  <span>接单车次(单)</span>
                  <strong>{{ pdcc }}</strong>
                </div>
              </el-tooltip>
              <div class="freight-stat-subgrid">
                <el-tooltip :content="String(jscc)" placement="top">
                  <div>
                    <span>出厂车次(单)</span>
                    <strong>{{ jscc }}</strong>
                  </div>
                </el-tooltip>
                <el-tooltip :content="String(wccc)" placement="top">
                  <div>
                    <span>完成车次(单)</span>
                    <strong>{{ wccc }}</strong>
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div class="freight-stat-card freight-stat-card-weight">
              <div class="freight-stat-card-head">
                <div class="freight-stat-icon">
                  <img src="../../assets/images/orderStatistics/weight.png" />
                </div>
                <div>
                  <p class="freight-stat-title">重量</p>
                  <p class="freight-stat-desc">接单 / 出厂 / 卸货</p>
                </div>
              </div>
              <el-tooltip :content="String(pdzl)" placement="top">
                <div class="freight-stat-main">
                  <span>接单重量(吨)</span>
                  <strong>{{ pdzl }}</strong>
                </div>
              </el-tooltip>
              <div class="freight-stat-subgrid">
                <el-tooltip :content="String(jszl)" placement="top">
                  <div>
                    <span>出厂重量(吨)</span>
                    <strong>{{ jszl }}</strong>
                  </div>
                </el-tooltip>
                <el-tooltip :content="String(wczl)" placement="top">
                  <div>
                    <span>完成重量(吨)</span>
                    <strong>{{ wczl }}</strong>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    <div class="billOperationRecord-table pulbic_table_container dispatch-section-wrap">
      <div class="dispatch-section-head dispatch-table-head">
        <div>
          <h3 class="dispatch-section-title">订单明细</h3>
          <p class="dispatch-section-desc">支持展开查看完整字段，主表只保留核心信息，减少左右拖动。</p>
        </div>
        <div class="dispatch-table-tools">
          <span class="dispatch-table-tip">点击行可展开完整字段</span>
          <span class="dispatch-table-meta">共 {{ pagingPageMo || 0 }} 条记录</span>
        </div>
      </div>
      <el-table
        ref="freightTable"
        tooltip-effect="dark"
        :data="tableData"
        style="width: 100%;"
        empty-text="暂无订单数据，请调整筛选条件后重试"
        :default-sort="{ prop: 'waterNum', order: 'descending' }"
        :header-cell-style="{
          color: 'rgba(51,51,51,1)',
          background: 'rgba(184,227,255,1)',
          'font-weight': 'bold',
        }"
        class="public_tableColumn freight-ux-table"
        @row-click="handleFreightRowClick"
      >
        <el-table-column type="expand" width="42">
          <template slot="header">
            <el-tooltip content="展开查看完整字段" placement="top">
              <span class="freight-expand-header">详</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div class="dispatch-expand-panel">
              <div class="dispatch-expand-section">
                <div class="dispatch-expand-title">基础信息</div>
                <div class="dispatch-expand-grid">
                  <div class="dispatch-expand-item">
                    <span>接单编号</span>
                    <strong>{{ scope.row.ORMTB470CA00 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>装货地</span>
                    <strong>{{ scope.row.ORMTB470CA05 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>卸货地</span>
                    <strong>{{ scope.row.ORMTB470CA33 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>发单人</span>
                    <strong>{{ scope.row.ORMTB470CA40 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>货主</span>
                    <strong>{{ scope.row.ORMTB410CA04 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
                    <span>接单人</span>
                    <strong>{{ scope.row.ORMTB470CA12 || '' }}</strong>
                  </div>
                </div>
              </div>
              <div class="dispatch-expand-section">
                <div class="dispatch-expand-title">运输与结算</div>
                <div class="dispatch-expand-grid">
                  <div class="dispatch-expand-item">
                    <span>车牌号</span>
                    <strong>{{ scope.row.ORMTB470CA01 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>订单物料</span>
                    <strong>{{ scope.row.ORMTB470CA07 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>出厂物料</span>
                    <strong>{{ scope.row.ORMTB470CA19 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>接单重量</span>
                    <strong>{{ scope.row.ORMTB470CB02 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>运费(每吨)</span>
                    <strong>{{ scope.row.ORMTB470CA14 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>出厂结算时间</span>
                    <strong>{{ scope.row.ORMTB470CA17 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>完成结算时间</span>
                    <strong>{{ scope.row.ORMTB470CC02 || '' }}</strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>出厂结算金额</span>
                    <strong v-if="scope.row.ORMTB470CA23">{{ Number(scope.row.ORMTB470CA23 + scope.row.ORMTB470CA31).toFixed('2') }}</strong>
                    <strong v-if="!scope.row.ORMTB470CA23"></strong>
                  </div>
                  <div class="dispatch-expand-item">
                    <span>完成结算金额</span>
                    <strong v-if="scope.row.ORMTB470CC06">{{ Number(scope.row.ORMTB470CC06 + scope.row.ORMTB470CC07).toFixed('2') || '' }}</strong>
                    <strong v-if="!scope.row.ORMTB470CC06"></strong>
                  </div>
                </div>
              </div>
              <div class="dispatch-expand-section" v-if="tableHeadList && tableHeadList.length">
                <div class="dispatch-expand-title">已选展示字段</div>
                <div class="dispatch-expand-grid">
                  <div
                    class="dispatch-expand-item"
                    v-for="(item, index) in tableHeadList"
                    :key="'expand-' + index"
                  >
                    <span>{{ item.label }}</span>
                    <strong>{{ scope.row[item.prop] === 0 ? 0 : scope.row[item.prop] || '' }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ORMTB470CA16"
          sortable
          width="188"
          label="接单时间"
        >
          <template slot-scope="scope">
            <div class="dispatch-time-card">
              <span class="dispatch-time-kicker">接单时间</span>
              <strong>{{ scope.row.ORMTB470CA16 || '' }}</strong>
              <el-tooltip
                :content="scope.row.ORMTB470CA00 || ''"
                placement="top"
                :disabled="!scope.row.ORMTB470CA00"
              >
                <span class="dispatch-time-code">编号：{{ scope.row.ORMTB470CA00 || '' }}</span>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="240" label="运输核心">
          <template slot-scope="scope">
            <div class="freight-main-card">
              <div class="freight-main-head">
                <span>车牌</span>
                <el-tooltip
                  :content="scope.row.ORMTB470CA01 || ''"
                  placement="top"
                  :disabled="!scope.row.ORMTB470CA01"
                >
                  <strong>{{ scope.row.ORMTB470CA01 || '' }}</strong>
                </el-tooltip>
              </div>
              <div class="freight-route-list">
                <div class="freight-route-row">
                  <span class="freight-route-mark freight-route-mark-load">装</span>
                  <el-tooltip
                    :content="scope.row.ORMTB470CA05 || ''"
                    placement="top"
                    :disabled="!scope.row.ORMTB470CA05"
                  >
                    <p>{{ scope.row.ORMTB470CA05 || '' }}</p>
                  </el-tooltip>
                </div>
                <div class="freight-route-row">
                  <span class="freight-route-mark freight-route-mark-unload">卸</span>
                  <el-tooltip
                    :content="scope.row.ORMTB470CA33 || ''"
                    placement="top"
                    :disabled="!scope.row.ORMTB470CA33"
                  >
                    <p>{{ scope.row.ORMTB470CA33 || '' }}</p>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="220" label="货主物料">
          <template slot-scope="scope">
            <div class="freight-info-list">
              <div class="freight-info-row freight-info-row-primary">
                <span>货主</span>
                <el-tooltip
                  :content="scope.row.ORMTB410CA04 || ''"
                  placement="top"
                  :disabled="!scope.row.ORMTB410CA04"
                >
                  <strong>{{ scope.row.ORMTB410CA04 || '' }}</strong>
                </el-tooltip>
              </div>
              <div class="freight-info-row">
                <span>订单物料</span>
                <el-tooltip
                  :content="scope.row.ORMTB470CA07 || ''"
                  placement="top"
                  :disabled="!scope.row.ORMTB470CA07"
                >
                  <p>{{ scope.row.ORMTB470CA07 || '' }}</p>
                </el-tooltip>
              </div>
              <div class="freight-info-row">
                <span>出厂物料</span>
                <el-tooltip
                  :content="scope.row.ORMTB470CA19 || ''"
                  placement="top"
                  :disabled="!scope.row.ORMTB470CA19"
                >
                  <p>{{ scope.row.ORMTB470CA19 || '' }}</p>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="190" label="人员信息">
          <template slot-scope="scope">
            <div class="freight-info-list freight-info-list-people">
              <div class="freight-info-row">
                <span>发单人</span>
                <el-tooltip
                  :content="scope.row.ORMTB470CA40 || ''"
                  placement="top"
                  :disabled="!scope.row.ORMTB470CA40"
                >
                  <p>{{ scope.row.ORMTB470CA40 || '' }}</p>
                </el-tooltip>
              </div>
              <div class="freight-info-row" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
                <span>接单人</span>
                <el-tooltip
                  :content="scope.row.ORMTB470CA12 || ''"
                  placement="top"
                  :disabled="!scope.row.ORMTB470CA12"
                >
                  <p>{{ scope.row.ORMTB470CA12 || '' }}</p>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="190" label="重量金额">
          <template slot-scope="scope">
            <div class="dispatch-amount-cell dispatch-amount-cell-premium">
              <div class="dispatch-amount-block">
                <span>接单重量</span>
                <strong>{{ scope.row.ORMTB470CB02 || '' }}</strong>
              </div>
              <div class="dispatch-amount-block">
                <span>运费/吨</span>
                <strong>{{ scope.row.ORMTB470CA14 || '' }}</strong>
              </div>
              <div class="dispatch-amount-block dispatch-amount-block-highlight">
                <span>出厂金额</span>
                <strong v-if="scope.row.ORMTB470CA23">{{ Number(scope.row.ORMTB470CA23 + scope.row.ORMTB470CA31).toFixed('2') }}</strong>
                <strong v-if="!scope.row.ORMTB470CA23"></strong>
              </div>
              <div class="dispatch-amount-block dispatch-amount-block-highlight">
                <span>完成金额</span>
                <strong v-if="scope.row.ORMTB470CC06">{{ Number(scope.row.ORMTB470CC06 + scope.row.ORMTB470CC07).toFixed('2') || '' }}</strong>
                <strong v-if="!scope.row.ORMTB470CC06"></strong>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="160" label="状态">
          <template slot="header">
            <el-tooltip content="完成、申请和来源状态" placement="top">
              <span>状态</span>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <div class="dispatch-status-stack dispatch-status-card-stack">
              <div class="dispatch-status-line dispatch-status-line-primary">
                <span>完成</span>
                <strong>{{ scope.row.ORMTB440CF01text || '' }}</strong>
              </div>
              <div class="dispatch-status-line">
                <span>申请</span>
                <strong>{{ scope.row.auditText || '' }}</strong>
              </div>
              <div class="dispatch-status-line dispatch-status-line-source">
                <span>来源</span>
                <strong>{{ scope.row.source == 0 ? '客户' : '平台' }}</strong>
              </div>
              <div class="dispatch-status-icons">
                <img
                  v-if="
                    scope.row.ORMTB470CN18&&
                      uobj.pertb005.pertb005cb00 == 'CUS-1'
                  "
                  class="imgStatistics"
                  src="../../assets/images/orderStatistics/cd.png"
                />
                <img
                  v-if="
                    scope.row.ORMTB470CN00 == '1' &&
                      uobj.pertb005.pertb005cb00 == 'CUS-1'
                  "
                  class="imgStatistics"
                  src="../../assets/images/orderStatistics/xg.png"
                />
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="
            this.uobj.pertb005.pertb005cb00 == 'CUS-1' ||
              this.uobj.pertb005.pertb005cb00 == 'CUS-2'
          "
          label="操作"
          fixed="right"
          width="150"
        >
          <template slot-scope="scope">
            <div class="dispatch-table-actions dispatch-table-actions-compact" @click.stop>
              <el-tooltip content="查看订单详情" placement="top">
                <el-button
                  class="public_icon_xiangqing public_icon_width public_icon_margin"
                  type="primary"
                  size="small"
                  @click="DetailsClick(scope.row)"
                  >详情</el-button
                >
              </el-tooltip>
              <el-dropdown trigger="click" @command="handleFreightOrderAction($event, scope.row)">
                <el-button type="primary" size="small" class="dispatch-more-btn">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" class="dispatch-action-menu">
                  <el-dropdown-item
                    v-if="
                      scope.row.ORMTB440CF01text == '已接单' ||
                        scope.row.ORMTB440CF01text == '提货中'
                    "
                    command="qrCode"
                    >查看二维码</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      (scope.row.ORMTB470CD00 == 0 ||
                        scope.row.ORMTB470CD00 == -1 ||
                        scope.row.ORMTB470CD00 == -2 ||
                        scope.row.ORMTB470CD00 == 1) &&
                        scope.row.ORMTB470CA62 == 0 &&
                        uobj.pertb005.pertb005cb00 == 'CUS-1'
                    "
                    command="freeze"
                    id="冻结"
                    v-shiroHiden="solelist"
                    >冻结</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      (scope.row.ORMTB470CD00 == 0 ||
                        scope.row.ORMTB470CD00 == -1 ||
                        scope.row.ORMTB470CD00 == -2 ||
                        scope.row.ORMTB470CD00 == 1) &&
                        scope.row.ORMTB470CA62 == 1 &&
                        uobj.pertb005.pertb005cb00 == 'CUS-1'
                    "
                    command="unfreeze"
                    id="解冻"
                    v-shiroHiden="solelist"
                    >解冻</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.ORMTB470CA04 == '10000150' &&
                        scope.row.ORMTB470CN08 == 1
                    "
                    command="cancelPlan"
                    id="取消要货计划"
                    >取消要货计划</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.ORMTB470CD00 == '-2' &&
                        scope.row.ORMTB470CD01 == 0 &&
                        uobj.pertb005.pertb005cb00 == 'CUS-1'
                    "
                    command="auditCancel"
                    id="审核取消"
                    v-shiroHiden="solelist"
                    >审核取消</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="scope.row.ORMTB470CD00 == '3'"
                    command="auditWeight"
                    id="审核磅单"
                    v-shiroHiden="solelist"
                    >审核磅单</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.ORMTB470CD00 == '2' ||
                        scope.row.ORMTB470CD00 == '3' ||
                        scope.row.ORMTB470CD00 == '4'
                    "
                    command="writeOffWeight"
                    id="审核磅单"
                    v-shiroHiden="solelist"
                    >核销卸货磅单</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.ORMTB470CD00 == '2' ||
                        scope.row.ORMTB470CD00 == '3' ||
                        scope.row.ORMTB470CD00 == '4' ||
                        scope.row.ORMTB470CD00 == '5' ||
                        scope.row.ORMTB470CD00 == '-3'
                    "
                    command="uploadWeight"
                    id="上传磅单"
                    v-shiroHiden="solelist"
                    >上传卸货磅单</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.isauditOrder == 1 &&
                        uobj.pertb005.pertb005cb00 == 'CUS-1'
                    "
                    command="auditDispatch"
                    id="审核派单"
                    v-shiroHiden="solelist"
                    >审核派单</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.ORMTB440CF01 == 4 &&
                        uobj.pertb005.pertb005cb00 == 'CUS-1' &&
                        scope.row.ORMTB440CF00 == 'ZG'
                    "
                    command="receipt"
                    id="确认回执"
                    v-shiroHiden="solelist"
                    >确认回执</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.ORMTB430ID == 0 &&
                        scope.row.ORMTB470CD00 >= 0 &&
                        scope.row.ORMTB470CD00 < 2
                    "
                    command="uploadQr"
                    >上传二维码</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="
                      scope.row.ORMTB430ID == '0' &&
                        (scope.row.ORMTB470CD00 == 0 ||
                          scope.row.ORMTB470CD00 == '1' ||
                          scope.row.ORMTB470CD00 == '-1')
                    "
                    command="completeFactory"
                    id="出厂完成订单"
                    v-shiroHiden="solelist"
                    >出厂完成订单</el-dropdown-item
                  >
                  <el-dropdown-item
                    v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'"
                    command="mistakeOrder"
                    >错单处理</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <input
        ref="freightUploadInput"
        @change="inputFileChange"
        type="file"
        name="inputFile"
        style="display: none;"
      />
      <div class="pulbic_pagesize">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="limitMo"
          layout="total,sizes, prev, pager, next, jumper"
          :total="pagingPageMo"
        >
        </el-pagination>
      </div>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="详情"
        :visible.sync="oerderDetilsShow"
        width="86%"
        custom-class="dispatch-dialog freight-detail-dialog"
        @close="detailsList = ''"
        :closeOnClickModal="false"
        append-to-body
      >
        <div class="dispatch-dialog-intro freight-detail-intro">
          <div class="dispatch-dialog-intro-title">运费订单详情</div>
          <div class="dispatch-dialog-intro-desc">按核对顺序展示订单摘要、运输路线、基础规则、结算对比和磅单记录，减少来回查找。</div>
        </div>
        <div class="freight-detail-shell">
          <div class="freight-detail-hero">
            <div class="freight-detail-hero-main">
              <span class="freight-detail-eyebrow">流水号</span>
              <strong>{{ detailsList.ORMTB470CA00 || '' }}</strong>
              <div class="freight-detail-hero-sub">
                <span>接单时间：{{ detailsList.ORMTB470CA16 || '' }}</span>
                <span>票号：{{ detailsList.ORMTB470CA48 || '' }}</span>
              </div>
            </div>
            <div class="freight-detail-hero-grid">
              <div class="freight-detail-mini-card freight-detail-mini-card-car">
                <span>接单车号</span>
                <strong>{{ detailsList.ORMTB470CA01 || '' }}</strong>
              </div>
              <div class="freight-detail-mini-card">
                <span>发单人</span>
                <strong>{{ detailsList.ORMTB470CA40 || '' }}</strong>
              </div>
              <div class="freight-detail-mini-card">
                <span>货主</span>
                <strong>{{ detailsList.ORMTB410CA04 || '' }}</strong>
              </div>
              <div class="freight-detail-mini-card">
                <span>接单重量</span>
                <strong>{{ detailsList.ORMTB470CB02 || '' }}</strong>
              </div>
              <div class="freight-detail-mini-card">
                <span>订单物料</span>
                <strong>{{ detailsList.ORMTB470CA07 || '' }}</strong>
              </div>
              <div class="freight-detail-mini-card">
                <span>出厂物料</span>
                <strong>{{ detailsList.ORMTB470CA19 || '' }}</strong>
              </div>
            </div>
          </div>

          <div class="freight-detail-route">
            <div class="freight-detail-route-point freight-detail-route-start">
              <span>装</span>
              <div>
                <em>装货地</em>
                <strong>{{ detailsList.ORMTB470CA05 || '' }}</strong>
              </div>
            </div>
            <div class="freight-detail-route-line"><span></span></div>
            <div class="freight-detail-route-point freight-detail-route-end">
              <span>卸</span>
              <div>
                <em>卸货地</em>
                <strong>{{ detailsList.ORMTB470CA33 || '' }}</strong>
              </div>
            </div>
          </div>

          <div class="freight-detail-content">
            <div class="freight-detail-content-main">
              <div class="freight-detail-section">
                <div class="freight-detail-section-head">
                  <strong>基础参数</strong>
                  <span>运费、到货价和货损规则</span>
                </div>
                <div class="freight-detail-info-grid">
                  <div class="freight-detail-field freight-detail-field-primary">
                    <span>运费(每吨)</span>
                    <strong>{{ detailsList.ORMTB470CA14 || '' }}元</strong>
                  </div>
                  <div class="freight-detail-field freight-detail-field-primary">
                    <span>{{ detailsList.ORMTB460TP == 'SL' ? '直供' : '含货配送' }}到货价</span>
                    <strong>{{ detailsList.daohuoMoney || '' }}元</strong>
                  </div>
                  <div class="freight-detail-field">
                    <span>运费是否含税</span>
                    <strong>{{ detailsList.ORMTB470CA70 }}</strong>
                  </div>
                  <div class="freight-detail-field">
                    <span>亏吨范围(吨)</span>
                    <strong>{{ detailsList.ORMTB470CA50 || '' }}吨</strong>
                  </div>
                  <div class="freight-detail-field">
                    <span>超时取消时间(小时)</span>
                    <strong>{{ detailsList.ORMTB470CA54 || '' }}小时</strong>
                  </div>
                  <div class="freight-detail-field">
                    <span>卸货时间</span>
                    <strong>{{ detailsList.ORMTB460CA40 || '' }}</strong>
                  </div>
                  <div class="freight-detail-field freight-detail-field-wide">
                    <span>运费卸货净重规则</span>
                    <strong>{{ detailsList.ORMTB460CA38 || '' }}</strong>
                  </div>
                  <div class="freight-detail-field freight-detail-field-wide">
                    <span>运费结算甩零规则</span>
                    <strong>{{ detailsList.ORMTB460CA39 || '' }}</strong>
                  </div>
                </div>
              </div>

              <div class="freight-detail-section freight-detail-section-note">
                <div class="freight-detail-section-head">
                  <strong>时间与备注</strong>
                  <span>结算节点、异常说明和内部备注</span>
                </div>
                <div class="freight-detail-note-grid">
                  <div class="freight-detail-note-card">
                    <span>出厂结算时间</span>
                    <strong>{{ detailsList.ORMTB470CA17 || '' }}</strong>
                  </div>
                  <div class="freight-detail-note-card">
                    <span>完成结算时间</span>
                    <strong>{{ detailsList.ORMTB470CC02 || '' }}</strong>
                  </div>
                  <div class="freight-detail-note-card freight-detail-note-card-wide">
                    <span>原因</span>
                    <strong>{{ detailsList.ORMTB470CA29 || '' }}</strong>
                  </div>
                  <div class="freight-detail-note-card freight-detail-note-card-wide">
                    <span>磅单审核拒绝原因</span>
                    <strong>{{ detailsList.ORMTB470CA44 || '' }}</strong>
                  </div>
                  <div class="freight-detail-note-card freight-detail-note-card-wide" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
                    <span>修改流水备注</span>
                    <el-tooltip placement="top" :content="detailsList.ORMTB470CN01 || ''">
                      <strong>{{ detailsList.ORMTB470CN01 || '' }}</strong>
                    </el-tooltip>
                  </div>
                  <div class="freight-detail-note-card freight-detail-note-card-wide" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
                    <span>错单原因</span>
                    <el-tooltip placement="top" :content="detailsList.ORMTB470CN18 || ''">
                      <strong>{{ detailsList.ORMTB470CN18 || '' }}</strong>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>

            <div class="freight-detail-content-side">
              <div class="freight-detail-section freight-detail-section-compare">
                <div class="freight-detail-section-head">
                  <strong>结算对比</strong>
                  <span>接单 / 出厂 / 卸货</span>
                </div>
                <div class="freight-detail-compare freight-detail-compare-tight">
                  <div class="DWD-table dispatch-dialog-table dispatch-dialog-table-spaced">
                    <div class="DWD-table-left-title">
                      <div></div>
                      <div>接单</div>
                      <div>出厂</div>
                      <div>卸货</div>
                    </div>
                    <div class="DWD-table-left-flex">
                      <div>物料</div>
                      <div>{{ detailsList.ORMTB470CA07 || '' }}</div>
                      <div>{{ detailsList.ORMTB470CA19 || '' }}</div>
                      <div>{{ detailsList.ORMTB470CA19 || '' }}</div>
                    </div>
                    <div class="DWD-table-left-flex">
                      <div>单价</div>
                      <div>{{ detailsList.ORMTB470CA08 || '' }}</div>
                      <div>{{ detailsList.ORMTB470CA20 || '' }}</div>
                      <div>{{ detailsList.ORMTB470CA20 || '' }}</div>
                    </div>
                    <div class="DWD-table-left-flex">
                      <div>重量</div>
                      <div>{{ detailsList.ORMTB470CB02 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CA21 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CC08 || 0 }}</div>
                    </div>
                    <div class="DWD-table-left-flex">
                      <div>物料金额</div>
                      <div>{{ detailsList.ORMTB470CA09 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CA23 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CA23 || 0 }}</div>
                    </div>
                    <div class="DWD-table-left-flex">
                      <div>扣除运费</div>
                      <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CC06 || 0 }}</div>
                    </div>
                    <div class="DWD-table-left-flex">
                      <div>结算运费</div>
                      <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CC12 || 0 }}</div>
                    </div>
                    <div class="DWD-table-left-flex">
                      <div>额外费用</div>
                      <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
                      <div>{{ detailsList.ORMTB470CA72 || 0 }}</div>
                    </div>
                    <div
                      v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'"
                      class="DWD-table-left-flex"
                    >
                      <div>管理费</div>
                      <div>0</div>
                      <div>0</div>
                      <div>{{ detailsList.ORMTB470CA60 || 0 }}</div>
                    </div>
                    <div
                      v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'"
                      class="DWD-table-left-flex"
                    >
                      <div>运费补贴</div>
                      <div>0</div>
                      <div>0</div>
                      <div>{{ detailsList.ORMTB470CA71 || 0 }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="
                  (detailsList.ORMTB470CA67 &&
                    (detailsList.ORMTB470CA04 == '10000106' ||
                      detailsList.ORMTB470CA04 == '10000107' ||
                      detailsList.ORMTB440CA42 == '1')) ||
                    detailsList.ORMTB470CA35
                "
                class="freight-detail-section freight-detail-section-images"
              >
                <div class="freight-detail-section-head">
                  <strong>磅单记录</strong>
                  <span>点击图片可预览大图</span>
                </div>
                <div class="freight-detail-image-grid freight-detail-image-grid-tight">
                  <div
                    v-if="
                      detailsList.ORMTB470CA67 &&
                        (detailsList.ORMTB470CA04 == '10000106' ||
                          detailsList.ORMTB470CA04 == '10000107' ||
                          detailsList.ORMTB440CA42 == '1')
                    "
                    class="DetailsWater-img dispatch-dialog-figure freight-detail-figure-compact"
                  >
                    <div class="DetailsWater-img-text">出厂磅单</div>
                    <el-image
                      style="width: 84px; height: 84px"
                      :src="detailsList.ORMTB470CA67"
                      :preview-src-list="DetailsWeightrcList"
                    >
                    </el-image>
                  </div>
                  <div v-if="detailsList.ORMTB470CA35" class="DetailsWater-img dispatch-dialog-figure freight-detail-figure-compact">
                    <div class="DetailsWater-img-text">卸货磅单</div>
                    <el-image
                      style="width: 84px; height: 84px"
                      :src="detailsList.ORMTB470CA35"
                      :preview-src-list="DetailsWeightrcList"
                    >
                    </el-image>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button @click="oerderDetilsShow = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="磅单审核"
        :visible.sync="orderAuditShow"
        @close="detailsList = ''"
        width="30%"
        custom-class="dispatch-dialog"
        :closeOnClickModal="false"
        append-to-body
      >
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">审核前确认磅单信息</div>
          <div class="dispatch-dialog-intro-desc">请先核对车辆、票号、重量和磅单图片，再执行通过或拒绝。</div>
        </div>
        <div class="DetailsWater-Dialog dispatch-detail-grid">
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">实际扣款人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB410CA04 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费(每吨)</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">装货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA33 || '' }}</div>
          </div>
          <!-- 	<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA05||''}}</div>
					</div> -->
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA19 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">出厂重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA21 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">出厂金额</div>
            <div class="DWD-li-text">
              {{
                Number(
                  detailsList.ORMTB470CA23 + detailsList.ORMTB470CA31
                ).toFixed('2')
              }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">
              <!-- <div class="DWD-li-text">{{detailsList.ORMTB470CA01||''}}</div> -->
              <input
                type="text"
                v-model="detailsList.ORMTB470CA01"
                placeholder="请输入车号"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">票号</div>
            <div class="DWD-li-text">
              <input
                type="text"
                v-model="detailsList.ORMTB470CA48"
                placeholder="请输入票号"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货重量</div>
            <div class="DWD-li-text">
              <!-- <div class="DWD-li-text">{{detailsList.ORMTB470CC05||''}}</div> -->
              <input
                type="number"
                v-model="detailsList.ORMTB470CC05"
                placeholder="请输入卸货重量"
              />
            </div>
          </div>
          <div class="DetailsWater-img dispatch-dialog-figure">
            <div class="DetailsWater-img-text">磅单</div>
            <el-image
              style="width: 80px; height: 80px"
              :src="detailsList.ORMTB470CA35"
              :preview-src-list="DetailsWeightrcList"
            >
            </el-image>
          </div>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button type="primary" @click="examineOrder">通过</el-button>
          <el-button type="danger" @click="updateOrder">拒绝</el-button>
        </div>
      </el-dialog>
    </div>

    <div class="public-dialog">
      <el-dialog
        title="磅单核销"
        :visible.sync="orderAuditShow1"
        @close="detailsList = ''"
        width="30%"
        custom-class="dispatch-dialog"
        :closeOnClickModal="false"
        append-to-body
      >
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">核销卸货磅单</div>
          <div class="dispatch-dialog-intro-desc">当前仅调整展示排版，原有运费、卸货重量和结算逻辑保持不变。</div>
        </div>
        <div class="DetailsWater-Dialog dispatch-detail-grid">
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">实际扣款人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB410CA04 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单运费(每吨)</div>
            <!-- <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div> -->
            <div class="DWD-li-text">
              <input
                style="border: none;"
                @input="handInput"
                type="number"
                step="0.01"
                v-model="detailsList.ORMTB470CA14"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">发单运费(每吨)</div>
            <!-- <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div> -->
            <div class="DWD-li-text">
              <input
                style="border: none;"
                @input="handInput"
                type="number"
                step="0.01"
                v-model="detailsList.ORMTB470CA52"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">装货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货地</div>
            <!-- <div class="DWD-li-text">{{ detailsList.ORMTB470CA33 || '' }}</div> -->
            <div class="DWD-li-text">
              <input
                style="border: none;"
                @input="handInput"
                type="text"
                v-model="detailsList.ORMTB470CA33"
              />
            </div>
          </div>
          <!-- 	<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA05||''}}</div>
					</div> -->
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA19 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货重量</div>
            <div class="DWD-li-text">
              <input
                type="number"
                v-model="detailsList.ORMTB470CC05"
                maxlength="10"
                @input="inputWeightFormat($event, 'tare', 'hx')"
              />
            </div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">金额</div>
						<div class="DWD-li-text">
							{{Number(detailsList.ORMTB470CA23+detailsList.ORMTB470CA31).toFixed('2')}}
						</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA01 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费结算方式</div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA58 == '1'">
              线上结算
            </div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA58 == '2'">
              线下结算
            </div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA58 == '3'">
              延迟结算
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">额外扣除司机费用</div>
            <!-- <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div> -->
            <div class="DWD-li-text">
              <input
                @input="handInput"
                style="border: none;"
                type="number"
                step="0.01"
                v-model="detailsList.ORMTB470CA72"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">扣除运费</div>
            <div class="DWD-li-text">{{ settlement }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">结算运费</div>
            <div class="DWD-li-text">{{ jsyfgsj }}</div>
          </div>
          <div class="DetailsWater-img dispatch-dialog-figure">
            <div class="DetailsWater-img-text">磅单</div>
            <el-image
              style="width: 80px; height: 80px"
              :src="detailsList.ORMTB470CA35"
              :preview-src-list="DetailsWeightrcList"
            >
            </el-image>
          </div>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button type="primary" @click="examineWriteOffOrder"
            >确定</el-button
          >
          <!-- <el-button type="danger" @click="updateOrder">拒绝</el-button> -->
        </div>
      </el-dialog>
    </div>

    <div class="public-dialog">
      <el-dialog
        title="上传磅单"
        :visible.sync="orderAuditShow2"
        @close="detailsList = ''"
        width="30%"
        custom-class="dispatch-dialog"
        :closeOnClickModal="false"
        append-to-body
      >
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">补充卸货磅单</div>
          <div class="dispatch-dialog-intro-desc">保留原有上传与预览流程，只优化信息排布，方便先核对再上传。</div>
        </div>
        <div class="DetailsWater-Dialog dispatch-detail-grid">
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费(每吨)</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA14 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">装货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA33 || '' }}</div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA01 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA19 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CB02 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">出厂重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA21 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货重量</div>
            <div class="DWD-li-text">
              <input
                type="number"
                v-model="detailsList.ORMTB470CC05"
                maxlength="10"
                @input="inputWeightFormat($event, 'tare')"
              />
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">票号</div>
            <div class="DWD-li-text">
              <input type="text" v-model="detailsList.ph" />
            </div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">金额</div>
						<div class="DWD-li-text">
							{{Number(detailsList.ORMTB470CA23+detailsList.ORMTB470CA31).toFixed('2')}}
						</div>
					</div> -->

          <div class="DetailsWater-img dispatch-dialog-figure">
            <div class="DetailsWater-img-text" style="font-size: 20px;">
              磅单
            </div>

            <!-- :before-upload="beforeAvatarUpload" -->
            <el-upload
              action="#"
              class="upload-demo"
              ref="upload"
              style="padding-top: 10px;font-size: 15px;"
              :multiple="false"
              list-type="picture"
              :http-request="UploadImage"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleRemove"
              :limit="1"
              :on-change="handleChange"
              :on-exceed="handleExceed"
              :file-list="formData.fileList"
            >
              <i class="el-icon-upload" style=""></i>
              <div style="display: inline-block;padding-left: 10px;">
                <em>点击上传</em>
              </div>
            </el-upload>
            <div
              class="demo-image__preview"
              v-if="dialogVisible == true"
              style="padding-top: 20px;"
            >
              <el-image
                style="width: 100px; height: 100px"
                :src="dialogImageUrl"
                :preview-src-list="bdurlList"
              >
              </el-image>
              <div class="">
                点击图片查看大图
              </div>
            </div>
            <!-- <el-dialog :modal="false" :visible.sync="dialogVisible">
							<img width="100%" :src="dialogImageUrl" alt="" />
							
							<div class="demo-image__preview">
							  <el-image v-if="dialogVisible == true" 
							    style="width: 100px; height: 100px"
							    :src="formData.fileList" 
							    :preview-src-list="formData.fileList">
							  </el-image>
							</div>
						</el-dialog> -->

            <!-- <el-image style="width: 80px; height: 80px" :src="detailsList.ORMTB470CA35"
							:preview-src-list="DetailsWeightrcList">
						</el-image> -->
          </div>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button type="primary" @click="examinebdOffOrder">提交</el-button>
          <!-- <el-button type="danger" @click="updateOrder">拒绝</el-button> -->
        </div>
      </el-dialog>
    </div>

    <div class="public-dialog">
      <el-dialog
        title="审核"
        :visible.sync="isorderAuditShow"
        @close=";(detailsList = ''), (isorderAuditText = '')"
        width="30%"
        custom-class="dispatch-dialog"
        :closeOnClickModal="false"
        append-to-body
      >
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">审核取消申请</div>
          <div class="dispatch-dialog-intro-desc">建议先核对订单核心信息和发起方，再填写审核说明并提交处理结果。</div>
        </div>
        <div class="DetailsWater-Dialog dispatch-detail-grid">
          <div class="DWD-li">
            <div class="DWD-li-title">发单人</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA40 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">装货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">卸货地</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA33 || '' }}</div>
          </div>
          <!-- 	<div class="DWD-li">
						<div class="DWD-li-title">企业名称</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA05||''}}</div>
					</div> -->
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{detailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA07 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CB02 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料金额</div>
            <div v-if="" class="DWD-li-text">
              {{ detailsList.ORMTB470CA09 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">运费</div>
            <div v-if="" class="DWD-li-text">
              {{ detailsList.ORMTB470CA10 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单车号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB470CA01 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">发起取消者</div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA41 == '0'">
              接单人
            </div>
            <div class="DWD-li-text" v-if="detailsList.ORMTB470CA41 == '1'">
              发单人
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">审核说明</div>
            <div class="DWD-li-text">
              <input type="text" v-model="isorderAuditText" maxlength="20" />
            </div>
          </div>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button type="primary" @click="isorderAuditServe(1)"
            >通过</el-button
          >
          <el-button type="danger" @click="isorderAuditServe(2)"
            >拒绝</el-button
          >
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="详情"
        :visible.sync="returnReceiptShow"
        @close="detailsList = ''"
        width="30%"
        custom-class="dispatch-dialog"
        :closeOnClickModal="false"
        append-to-body
      >
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">补充回执信息</div>
          <div class="dispatch-dialog-intro-desc">仅优化录入区展示层级，回执重量和回执运费单价仍按原逻辑处理。</div>
        </div>
        <div class="CustomerfillingDig-tab dispatch-form-grid">
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">车牌号：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              {{ detailsList.ORMTB440CA01 || '' }}
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">回执物料：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              {{ detailsList.ORMTB440CA07 || '' }}
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">回执重量：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input
                ref="topWeight"
                type="text"
                v-model="detailsList.ORMTB440CE02"
                maxlength="10"
                @input="topWeightInput"
                @change="topWeightChange"
              />
            </div>
            <div class="CustomerfillingDig-tab-li-b">*必填*</div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">回执运费单价：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input
                ref="topMoney"
                type="text"
                v-model="detailsList.ORMTB440CA21"
                maxlength="10"
                @input="topMoneyInput"
                @change="topMoneyChange"
              />
            </div>
            <div class="CustomerfillingDig-tab-li-b">*必填*</div>
          </div>
        </div>
        <div class="DetailsWater-img dispatch-dialog-figure">
          <div class="DetailsWater-img-text">回执记录</div>
          <el-image
            style="width: 80px; height: 80px"
            :src="DetailsWaterurl"
            :preview-src-list="DetailsWatersrcList"
          >
          </el-image>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button type="primary" @click="returnReceiptserve">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="二维码详情"
        :visible.sync="ewmDetilsShow"
        width="35%"
        custom-class="dispatch-dialog"
        @close="ewmdetailsList = ''"
        :closeOnClickModal="false"
        append-to-body
      >
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">查看提货二维码</div>
          <div class="dispatch-dialog-intro-desc">用于快速核对订单、企业、车辆与接单重量信息，支持直接预览大图。</div>
        </div>
        <div class="DetailsWater-img dispatch-dialog-figure" style="text-align: center;">
          <!-- <div class="DetailsWater-img-text">二维码</div> -->
          <el-image
            style="width: 250px; height: 250px"
            :src="ewmdetailsList.ORMTB440CA22Img"
            :preview-src-list="ewmDetails"
          >
            >
          </el-image>
        </div>

        <div class="DetailsWater-Dialog dispatch-detail-grid">
          <div class="DWD-li">
            <div class="DWD-li-title">车牌号</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA01 || '' }}
            </div>
          </div>
          <!-- <div class="DWD-li">
						<div class="DWD-li-title">接单人</div>
						<div class="DWD-li-text">{{ewmdetailsList.ORMTB470CA12||''}}</div>
					</div> -->
          <div class="DWD-li">
            <div class="DWD-li-title">订单编号</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA00 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单时间</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA16 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">企业</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA05 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CA07 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">接单重量</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB470CB02 || '' }}
            </div>
          </div>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button @click="ewmDetilsShow = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog
        title="出厂完成订单"
        :visible.sync="inputWeightShow"
        @close="inputWeightClose"
        width="760px"
        custom-class="dispatch-dialog factory-complete-dialog"
        :closeOnClickModal="false"
        append-to-body
      >
        <div class="dispatch-dialog-intro factory-complete-intro">
          <div>
            <div class="dispatch-dialog-intro-title">录入出厂结算信息</div>
            <div class="dispatch-dialog-intro-desc">先核对厂家和客户，再填写结算物料、单价与净重，系统会自动带出结算金额。</div>
          </div>
        </div>
        <div class="factory-complete-shell">
          <div class="factory-complete-guide">
            <span class="is-done">1. 核对订单信息</span>
            <span :class="{ 'is-done': factoryMaterialReady && factoryPriceReady && factoryTareReady }">2. 填写结算数据</span>
            <span :class="{ 'is-done': !factoryUploadVisible || factoryUploadReady, 'is-optional': factoryUploadVisible && !factoryUploadRequired }">
              {{ factoryUploadVisible ? '3. 上传磅单后提交' : '3. 确认后提交' }}
            </span>
          </div>
          <div class="factory-complete-progress">
            <div class="factory-complete-progress-info">
              <span>必填完成度</span>
              <strong>{{ factoryCompleteDoneCount }}/{{ factoryCompleteTotalCount }}</strong>
            </div>
            <div class="factory-complete-progress-track">
              <i :style="{ width: factoryCompletePercent + '%' }"></i>
            </div>
          </div>
          <div class="factory-complete-summary">
            <div class="factory-complete-summary-card factory-complete-summary-card-main">
              <span>厂家</span>
              <strong>{{ detailsList.ORMTB470CA05 || '' }}</strong>
            </div>
            <div class="factory-complete-summary-card">
              <span>客户</span>
              <strong>{{ detailsList.ORMTB410CA04 || '' }}</strong>
            </div>
            <div class="factory-complete-summary-card">
              <span>车牌号</span>
              <strong>{{ detailsList.ORMTB470CA01 || '' }}</strong>
            </div>
            <div class="factory-complete-summary-card">
              <span>订单编号</span>
              <strong>{{ detailsList.ORMTB470CA00 || '' }}</strong>
            </div>
          </div>

          <div class="factory-complete-section">
            <div class="factory-complete-section-title">
              <span>结算录入</span>
              <em>物料、单价和净重会参与结算金额计算</em>
            </div>
            <div class="CustomerfillingDig-tab dispatch-form-grid factory-complete-form">
              <div class="CustomerfillingDig-tab-li factory-complete-required factory-complete-field-wide">
                <div class="CustomerfillingDig-tab-li-text">出厂结算物料<span class="factory-required-mark">*</span></div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <div class="factory-complete-select-wrap">
                    <el-select
                      v-model="materialValue"
                      placeholder="请选择出厂结算物料"
                      @change="materialChange"
                    >
                      <el-option
                        v-for="item in materialList"
                        :key="item.value"
                        :label="item.lable"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="CustomerfillingDig-tab-li-b" :class="{ 'is-done': factoryMaterialReady }">
                  {{ factoryMaterialReady ? '已选' : '待选' }}
                </div>
              </div>
              <div class="CustomerfillingDig-tab-li factory-complete-required">
                <div class="CustomerfillingDig-tab-li-text">单价<span class="factory-field-unit">元/吨</span></div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <input
                    @input="inputWeightFormat1($event, 'price')"
                    type="number"
                    v-model="weightOpt.price"
                    maxlength="10"
                    placeholder="请输入单价，最多两位小数"
                  />
                </div>
                <div class="CustomerfillingDig-tab-li-b" :class="{ 'is-done': factoryPriceReady }">
                  {{ factoryPriceReady ? '已填' : '待填' }}
                </div>
              </div>
              <div class="CustomerfillingDig-tab-li factory-complete-required">
                <div class="CustomerfillingDig-tab-li-text">净重<span class="factory-required-mark">*</span><span class="factory-field-unit">吨</span></div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <input
                    type="text"
                    @input="inputWeightFormat($event, 'tare')"
                    v-model="weightOpt.tare"
                    maxlength="10"
                    placeholder="请输入净重，最多两位小数"
                  />
                </div>
                <div class="CustomerfillingDig-tab-li-b" :class="{ 'is-done': factoryTareReady }">
                  {{ factoryTareReady ? '已填' : '必填' }}
                </div>
              </div>
              <div class="CustomerfillingDig-tab-li factory-complete-amount factory-complete-field-wide">
                <div class="CustomerfillingDig-tab-li-text">结算金额<span class="factory-field-unit">元</span></div>
                <div class="CustomerfillingDig-tab-li-ipt">
                  <input
                    type="text"
                    v-model="weightOpt.jsprice"
                    maxlength="100"
                    :disabled="dcjsiput"
                    placeholder="系统自动计算"
                  />
                </div>
                <div class="CustomerfillingDig-tab-li-b" :class="{ 'is-done': factoryAmountReady }">
                  {{ factoryAmountReady ? '已计算' : '自动' }}
                </div>
              </div>
            </div>
            <div class="factory-complete-assist">
              {{ factoryCompleteAssistText }}
            </div>
          </div>

          <div
            class="factory-complete-section factory-complete-upload-section"
            v-if="
              detailsList.ORMTB470CA04 == '10000106' ||
                detailsList.ORMTB470CA04 == '10000107' ||
                detailsList.ORMTB470CA66 == '1'
            "
          >
            <div class="factory-complete-section-title factory-complete-section-title-upload">
              <span>出厂磅单</span>
              <em>{{ factoryUploadRequired ? '必传 1 张，上传后可点击图片预览' : '可选上传 1 张，上传后可点击图片预览' }}</em>
            </div>
            <div class="Customer-upload-bd factory-complete-upload-card" :class="{ 'is-done': factoryUploadReady }">
              <div class="factory-complete-upload-tip">
                <span>{{ factoryUploadStatusText }}</span>
                <em>{{ factoryUploadReady ? '如需更换，请先移除当前图片后重新上传。' : '请尽量上传清晰完整的磅单照片，便于后续核对。' }}</em>
              </div>
              <el-upload
                action=""
                list-type="picture"
                :class="{ disabled: uploadDisabled }"
                :auto-upload="false"
                :limit="1"
                ref="upload"
                :on-success="handleChangeSuccess"
                :on-change="handleChangezjccbd"
                :on-preview="handlePictureCardPreviewzjccbd"
                :on-remove="handleRemovezjccbd"
                :file-list="fileListccbd"
              >
                <el-button size="small" type="primary" class="factory-upload-btn">
                  <i class="el-icon-upload"></i>点击上传磅单
                </el-button>
              </el-upload>
              <el-dialog :visible.sync="dialogVisibleimg" append-to-body custom-class="sales-freight-order-dialog">
                <img width="80%" :src="dialogImageUrlzjccbd" alt="" />
              </el-dialog>
            </div>
          </div>
        </div>
        <div class="dispatch-dialog-footer factory-complete-footer">
          <div class="factory-complete-submit-tip" :class="{ 'is-ready': factorySubmitReady }">
            {{ factorySubmitTipText }}
          </div>
          <div class="factory-complete-footer-actions">
            <el-button @click="inputWeightShow = false">取消</el-button>
            <el-button type="primary" @click="inputWeightConfirm">确定提交</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
import { createLogger } from 'vuex'
import debounce from '../../api/debounce'
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'
export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
  data() {
    return {
      weightOpt: {
        tare: '',
        gross: '',
        jsprice: '',
        price: '',
      },
      loadingBut: false,
      confirmTxt: 0,
      inputWeightShow: false, // 输入磅单信息弹窗
      isorderAuditText: '',
      oerderDetilsShow: false,
      orderAuditShow: false,
      orderAuditShow1: false,
      orderAuditShow2: false,
      isorderAuditShow: false,
      returnReceiptShow: false,
      uobj: this.$store.state.uobj, //登陆缓存--用户信息
      date: [], //日期
      startTime: '',
      endTime: '',
      dateNowDayActive: false,
      dateYesterdayActive: false,
      dateNowMonthActive: false,
      dateLastMonthActive: false,
      twolevelUserLogin: true,
      timeIndex: 0, //判断第几次切换当月时间
      sameMonthTime: '', //目前月份
      currentMonthTime: '', //目前月份--上月+1
      tableData: [],
      ORMTB440CA00: '',
      ORMTB470CA12: '',
      ORMTB470CA40: '',
      ORMTB410CA04: '',
      materialOptions: [],
      materialTypeValue: '',
      carNum: '',
      materielMo: '',
      materielOptions: [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ],
      // 结算方式
      dataStatusOperation0: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '线上结算',
        },
        {
          value: '2',
          label: '线下结算',
        },
      ],

      // 状态
      dataStatusOperation: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '0',
          label: '已接单',
        },
        {
          value: '1',
          label: '提货中',
        },
        {
          value: '2',
          label: '已出厂',
        },
        {
          value: '3',
          label: '待审核磅单',
        },
        {
          value: '4',
          label: '待完成磅单',
        },
        {
          value: '5',
          label: '完成',
        },
        {
          value: '-1',
          label: '取消',
        },
        {
          value: '-2',
          label: '取消申请',
        },
      ],
      jscc: 0,
      jsje: 0,
      jszl: 0,
      jsyf: 0,
      pdcc: 0,
      pdje: 0,
      pdzl: 0,
      pdyf: 0,
      wccc: 0,
      wcje: 0,
      wcyf: 0,
      jsyfsjtj: 0,
      glf: 0,
      wczl: 0,
      // 查询
      customerMo: '', //客户--查询
      SETTB122CA07: '', //数据状态
      ORMTB470CA58: '', //运费结算状态
      billOperationAdd: false,
      enterpriseTwoOptionList: [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ], //二级企业下拉框--新增
      enterpriseTwo: '', //二级企业
      carNumber: '', //车牌号
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      currentPage: 1, //设置当前页默认为1
      // 列设置
      checkAll: true,
      checkedCities: [
        '派单时间',
        '派单编号',
        '企业名称',
        '客户名称',
        '车牌号',
        '订单物料',
        '出厂物料',
        '重量',
        '完成状态',
        '申请状态',
      ],
      filteredEnterpriseOptions: [],
      cities: [
        '派单时间',
        '派单编号',
        '企业名称',
        '客户名称',
        '车牌号',
        '订单物料',
        '出厂物料',
        '重量',
        '完成状态',
        '申请状态',
      ],
      isIndeterminate: false,
      // 详情
      billOperationDetails: false,
      detailsList: '', //详情列表
      tableHeadList: [
        // {
        // 	prop: 'ORMTB440CA19',
        // 	label: '派单时间',
        // 	width: 110
        // },
        // {
        // 	prop: 'ORMTB440CA00',
        // 	label: '派单编号',
        // 	width: 130
        // },
        // {
        // 	prop: 'ORMTB440CA05',
        // 	label: '企业名称',
        // },
        // {
        // 	prop: 'ORMTB440CA03',
        // 	label: '客户名称',
        // },

        {
          prop: 'ORMTB470CA01',
          label: '接单车号',
          width: 100,
        },
        {
          prop: 'ORMTB470CA07',
          label: '订单物料',
          width: 100,
        },
        {
          prop: 'ORMTB470CA19',
          label: '出厂物料',
          width: 100,
        },
        {
          prop: 'ORMTB470CB02',
          label: '接单重量',
          width: 100,
        },
        {
          prop: 'ORMTB470CA17',
          label: '出厂结算时间',
          width: 120,
        },
        {
          prop: 'ORMTB470CC02',
          label: '完成结算时间',
          width: 120,
        },
        // {
        // 	prop: 'ORMTB470CA23',
        // 	label: '出厂结算金额',
        // 	width: 120
        // },
        // {
        // 	prop: 'ORMTB470CA23',
        // 	label: '完成结算金额',
        // 	width: 120
        // },
        // {
        // 	prop: 'ORMTB470CA24',
        // 	label: '流水号',
        // 	width: 130
        // }
        // {
        // 	prop: 'ORMTB440CF01text',
        // 	label: '完成状态',
        // 	width: 100
        // },
        // {
        // 	prop: 'auditText',
        // 	label: '申请状态',
        // 	width: 100
        // }
      ],
      tableHeadListInit: [
        {
          prop: 'ORMTB470CA16',
          label: '派单时间',
        },
        {
          prop: 'ORMTB470CA00',
          label: '派单编号',
        },
        {
          prop: 'ORMTB470CA05',
          label: '企业名称',
        },
        {
          prop: 'ORMTB470CA12',
          label: '客户名称',
        },

        {
          prop: 'ORMTB470CA01',
          label: '车牌号',
        },
        {
          prop: 'ORMTB470CA07',
          label: '订单物料',
        },
        {
          prop: 'ORMTB440CC02',
          label: '完成物料',
        },
        {
          prop: 'ORMTB440CA10',
          label: '重量',
        },
        {
          prop: 'ORMTB440CF01text',
          label: '完成状态',
        },
        {
          prop: 'auditText',
          label: '申请状态',
        },
      ],
      // 离线订单
      orlxOrdeOptions: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      lxorde: '',
      examineObj: {},
      isRefresh: true,
      isRefreshSetInterval: '',
      // quanpDisabled: false,
      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      // 时间限制
      // 限制开始日期不能超过当前日期
      startDateDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      solelist: [],
      DetailsWaterurl: '',
      DetailsWatersrcList: [],
      DetailsWeightrcList: [],
      materialList: [],
      materialValue: '',
      listTick: null, // 列表刷新定时器
      timeType: '1',
      ewmDetilsShow: false,
      ewmDetails: [],
      ewmdetailsList: '', //二维码详情
      formData: {
        name: '',
        brand: '',
        unit: '',
        category: [],
        desc: '',
        fileList: [],
        img: [],
		fileId:''
      },
      isname: true,
      dialogImageUrl: undefined,
      videoFlag: false,
      uploadFileUrl: process.env.VUE_APP_BASE_API + '/system/image/uploadFile', // 上传的图片服务器地址
      dialogVisible: false,
      bdurlList: [],
      dcjsiput: true,

      /*/ 自建厂家出厂榜单data START/*/
      fileListccbd: [],
      dialogVisibleimg: false,
      formdata: new FormData(),
      dialogImageUrlzjccbd: '',
      addimg: [],
      removeimg: [],
      ruleForm: {
        csAvatar: '',
		fileId:''
      },
      orXgOrdeOptions: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      xgorde: '',
      orderId: '', //订单
      settlement: '', //扣除发单人运费
      jsyfgsj: '', //结算给司机运费
      /*/ 自建厂家出厂榜单data END/*/

      // headers: {
      //  Authorization: "Bearer " + getToken(),
      // }
      newOrderId: '', //订单ID
      dcmore: '',
	  
	  //错单
	  orCdOrdeOptions: [
	    {
	      value: '',
	      label: '全部',
	    },
	    {
	      value: '1',
	      label: '是',
	    },
	  ],
	  cdorde:'',
	  orderSource:'',//订单出处
	  orderSourceOpenOptions: [
	  		  {
	  		    value: '',
	  		    label: '全部'
	  		  },
	    {
	      value: 0,
	      label: '客户'
	    },
	    {
	      value: 1,
	      label: '平台'
	    }
	  ],
    }
  },
  watch: {
    weightOpt: {
      handler(val) {
        if ((val.tare || val.tare === 0) && (val.price || val.price === 0)) {
          let tare = parseFloat(val.tare)

          // let gross = parseFloat(val.gross)
          // debounce(this.getSettlementAmount, 500)
          // this.detailsList.ORMTB470CA21 = (tare - gross).toFixed(2)

          if (this.weightOpt.tare >= 0) {
            debounce(this.getSettlementAmount, 500)
          }
          // else {

          // }
        } else {
          // this.detailsList.ORMTB470CA21 = ''
          this.weightOpt.jsprice = ''
        }
      },
      deep: true,
    },
    // 'detailsList.ORMTB440CA04'() {
    //     this.getSelectMaterial()
    // }
  },
  created() {
    var list = ''
    list = this.$store.state.solelist
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
    // else {
    // 	this.getNowDay();
    // }
    var path = this.$route.path
    // console.log(path)
    if (path === '/SalesFreightOrder') {
      path = '/Home' + path
    }
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表
  },
  mounted() {
    if (this.historyInfo == null && this.$route.query.mark == null) {
      this.getNowDay()
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.dateNowDayActive = true
    }

    this.queryClick()
    this.enterprise0ptions()
    this.enterprise2Options()
    this.enterprise2Options()
  },
  activated() {
  },
  deactivated() {
  },
  // 存储数据
  beforeDestroy() {
    this.startTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.date[0]))
    this.endTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.date[1]))
    var obj = {
      startTime: this.startTime,
      endTime: this.endTime, //开始时间
      ORMTB440CA02: this.ORMTB440CA02, //客户id
      ORMTB400CA03: this.ORMTB400CA03, //客户名称
      ORMTB440CA04: this.ORMTB440CA04, //客户名称
      ORMTB440CA06: this.ORMTB440CA06, //二级企业id
      ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
      ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
      ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
      currentPage: this.currentPage, //当前页数
      pageMo: this.pageMo, //页码
      limitMo: this.limitMo, //每页条数
      dateNowDayActive: this.dateNowDayActive,
      dateYesterdayActive: this.dateYesterdayActive,
      dateNowMonthActive: this.dateNowMonthActive,
      dateLastMonthActive: this.dateLastMonthActive,
      ORMTB440CA00: this.ORMTB440CA00,
    }
    sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
  },
  computed: {
    uploadDisabled: function() {
      // console.log(this.ruleForm.csAvatar)
      return this.ruleForm.csAvatar != ''
    },
    factoryMaterialReady() {
      return !!this.materialValue
    },
    factoryPriceReady() {
      return this.weightOpt.price !== '' && this.weightOpt.price !== null && this.weightOpt.price !== undefined
    },
    factoryTareReady() {
      return this.weightOpt.tare !== '' && this.weightOpt.tare !== null && this.weightOpt.tare !== undefined
    },
    factoryAmountReady() {
      return this.weightOpt.jsprice !== '' && this.weightOpt.jsprice !== null && this.weightOpt.jsprice !== undefined
    },
    factoryUploadVisible() {
      return (
        this.detailsList.ORMTB470CA04 == '10000106' ||
        this.detailsList.ORMTB470CA04 == '10000107' ||
        this.detailsList.ORMTB470CA66 == '1'
      )
    },
    factoryUploadRequired() {
      return this.detailsList.ORMTB470CA04 == '10000106' || this.detailsList.ORMTB470CA66 == '1'
    },
    factoryUploadReady() {
      return this.ruleForm.csAvatar != '' || this.fileListccbd.length > 0
    },
    factoryCompleteTotalCount() {
      return this.factoryUploadRequired ? 3 : 2
    },
    factoryCompleteDoneCount() {
      let count = 0
      if (this.factoryMaterialReady && this.factoryTareReady) count += 2
      if (this.factoryUploadRequired && this.factoryUploadReady) count += 1
      return Math.min(count, this.factoryCompleteTotalCount)
    },
    factoryCompletePercent() {
      return Math.round((this.factoryCompleteDoneCount / this.factoryCompleteTotalCount) * 100)
    },
    factoryCompleteAssistText() {
      if (!this.factoryMaterialReady) return '请先选择出厂结算物料，系统会根据物料带出单价。'
      if (!this.factoryTareReady) return '请输入净重，填写后系统会自动计算结算金额。'
      if (!this.factoryAmountReady) return '结算金额正在等待系统计算，请确认单价和净重是否正确。'
      return '结算数据已填写完成，提交前请再次核对金额。'
    },
    factoryUploadStatusText() {
      if (this.factoryUploadReady) return '磅单已上传，可点击图片预览。'
      if (this.factoryUploadRequired) return '当前订单需要上传出厂磅单后才能提交。'
      return '当前订单可按需上传出厂磅单。'
    },
    factorySubmitReady() {
      return this.factoryMaterialReady && this.factoryTareReady && (!this.factoryUploadRequired || this.factoryUploadReady)
    },
    factorySubmitTipText() {
      if (!this.factoryMaterialReady) return '还需选择出厂结算物料。'
      if (!this.factoryTareReady) return '还需填写净重后再提交。'
      if (this.factoryUploadRequired && !this.factoryUploadReady) return '还需上传出厂磅单后再提交。'
      return '信息已基本完整，提交前请确认无误。'
    },
  },
  methods: {
    startListTimer() {
      if (this.listTick) return
      this.listTick = setInterval(() => {
        if (document.hidden) return
        this.queryClick()
      }, 1000 * 60)
    },
    stopListTimer() {
      if (!this.listTick) return
      clearInterval(this.listTick)
      this.listTick = null
    },
    handInput() {
      this.getFree()
    },
    //获取结算运费
    getFree() {
      var dataObj = {
        ORMTB470ID: this.examineObj.ORMTB470ID,
        ORMTB470CC05: this.detailsList.ORMTB470CC05,
        ORMTB470CA14: this.detailsList.ORMTB470CA14,
        ORMTB470CA33: this.detailsList.ORMTB470CA33,
        ORMTB470CA72: this.detailsList.ORMTB470CA72,
        ORMTB470CA52: this.detailsList.ORMTB470CA52 || 0,
      }
      this.axios.post('/request/yfBeforePay', dataObj).then(res => {
        if (res.data.code == 200) {
          console.log(res, 'oooo')
          this.settlement = res.data.data.ORMTB470CC06
          this.jsyfgsj = res.data.data.ORMTB470CC12
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    cancelPlan(row) {
      //取消要货计划
      this.axios
        .post('orm/ormtb470/cancelGoodsPlan', { ORMTB470ID: row.ORMTB470ID })
        .then(res => {
          if (res.data.code == 200) {
            console.log(res)
            this.$message({
              message: '成功',
              type: 'success',
            })
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
    },
    // 值改变 重新获取结算金额
    async materialChange(val) {
      if (val == this.detailsList.ORMTB470CA18) {
        this.weightOpt.price = this.detailsList.ORMTB470CA08
      } else {
        await this.queryMaterialPrice(val)
      }
      this.getSettlementAmount() //获取结算金额
    },
    // 根据物料id 查询单价
    async queryMaterialPrice(ORMTB440CC01) {
      let url = '/orm/ormtb440/unitPriceAuto'
      let params = {
        ORMTB440CC01, // 结算物料id
        ORMTB440CA02: this.detailsList.ORMTB410CA01, //客户id
        ORMTB440CA04: this.detailsList.ORMTB470CA04, // 二级企业ID
        ORMTB440ID: this.newOrderId,
      }
      params = qs.stringify(params)
      let header = {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
      let res = await this.axios.post(url, params, {
        header,
      })
      if (res.data.code === 200) {
        this.weightOpt.price = res.data.data
      }
    },
    //删除图片
    handleRemove(file, fileList) {
      console.log(file)
      //   判断是否是正确格式图片才能执行删除
      if (file && file.status === 'success') {
        let Pics = this.formData.fileList
        Pics.forEach((item, index) => {
          if (file.name == item.name) {
            Pics.splice(index, 1)
          }
        })
      }
      this.dialogImageUrl = ''
	  this.formData.fileId = ''
      this.bdurlList = []
      this.dialogVisible = false
      //   console.log(this.formData.fileList);
    },
    //查看图片
    handlePictureCardPreview(file) {
      // this.dialogImageUrl = file.url;
      console.log(file)
      // this.dialogVisible = true;
    },
    handleChange(file, fileList) {
      console.log(fileList)
      //   console.log(file);
    },

    getocrFun(data) {
      let loading = this.$loading({
        lock: true,
        text: '识别中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        url: data,
      }
      var url = '/orm/ormtb470/getOcr'

      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            console.log(res)
            // this.$message({
            // 	message: '成功',
            // 	type: 'success'
            // });
            // this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    //   手动上传
    //   submitUpload() {
    //     console.log(this.$refs.upload)
    //     this.$refs.upload.submit();
    //   },
    // 在使用http-request方法的时候，调用的事件必须以param为参数，通过param.file取得文件。
    UploadImage(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      // formData.append('ORMTB470CA00', this.ORMTB470CA00)
      let loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/system/uploadBD'

      this.axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            console.log(res)
            this.$message({
              message: res.data.data.message,
              type: 'success',
            })
            this.getocrFun(res.data.data.bdurl)
            this.formData.fileList.push({
              name: param.file.name,
              url: res.data.data.bdurl,
              uid: param.file.uid,
            })
            // this.pageList()
            this.dialogImageUrl = res.data.data.bdurl
			this.formData.fileId = res.data.data.fileId
            this.bdurlList.push(res.data.data.bdurl)
            this.dialogVisible = true
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })

      
    },
   
    //控制上传数量提示
    handleExceed(files, fileList) {
      this.$message.warning(`最多上传1个文件`)
    },

    /*/ 自建厂家出厂上传磅单START/*/
    handleChangeSuccess() {},

    handleChangezjccbd(file, fileList) {
      const isJPG =
        file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG 、png 格式!')
        fileList.splice(-1, 1) //移除错误文件
        return false
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!')
        fileList.splice(-1, 1)
        return false
      }

      this.addimg = fileList[0].raw
      // this.ruleForm.csAvatar = this.addimg;
      // console.log(file)
      // console.log(fileList)
      this.fileListccbd = []
      let data = new FormData()
      data.append('file', this.addimg)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/system/uploadBD'
      this.axios
        .post(url, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            // console.log(res)
            this.ruleForm.csAvatar = res.data.data.bdurl
			this.ruleForm.fileId = res.data.data.fileId
            this.fileListccbd = fileList
            // console.log(this.fileList)
            this.$message({
              message: res.data.data.message,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    // 删除活动展示照片
    handleRemovezjccbd(file, fileList) {
      // console.log(fileList)
      var index1 = this.ruleForm.csAvatar.lastIndexOf('2022', '2023')
      var imgdel = this.ruleForm.csAvatar.substring(index1)
      // console.log(imgdel)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb440/deleteFile'
      var postData = {
        fileName: imgdel,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            // console.log(res)
            this.ruleForm.csAvatar = ''
			this.ruleForm.fileId = ''
            this.formdata = new FormData()
            this.$message({
              message: res.data.message,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 活动展示照片预览
    handlePictureCardPreviewzjccbd(file) {
      this.dialogImageUrlzjccbd = file.url
      this.dialogVisibleimg = true
    },

    // 渲染编辑获取id
    applyzjccbd() {
      this.fileListccbd = [
        {
          url: '',
        },
      ] //这里是踩坑的点，必须写
      this.fileListccbd[0].url = res.data.csAvatar //这里是调用接口获取到的值 res.data.csAvatar，赋值就可以回显了
      //this.fileList[0].url 做的是单张图片回显，多张图片回显可以去掉[0]
    },

    /*/ 自建厂家出厂上传磅单END/*/

	cdclDetailsClick(row){//错单描述
			 var url = '/orm/ormtb470/updateCN17ById'
			      this.$prompt('请输入错单原因', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        inputPattern: /^.{1,}$/,
			        inputErrorMessage: '原因不能为空',
			      }).then(({ value }) => {
			        var postData = {
			          ORMTB470ID: row.ORMTB470ID,
			          ORMTB470CN18: value, //错单描述
			        }
			        let loading = this.$loading({
			          lock: true,
			          text: '请求中...',
			          spinner: 'el-icon-loading',
			          background: 'rgba(0, 0, 0, 0.5)',
			        })
			        this.axios
			          .post(url, postData)
			          .then(res => {
			            if (res.data.code == 200) {
			              this.pageList()
			              this.$message({
			                type: 'success',
			                message: res.data.message,
			              })
			            } else {
			              this.$message({
			                message: res.data.message,
			                type: 'error',
			              })
			            }
			            loading.close()
			          })
			          .catch(() => {
			            loading.close()
			          })
			      })
	},

    // 获取派单物料列表
    getSelectMaterial(row) {
      var postData = {
        SETTB99ID: row.ORMTB470CA04,
      }
      this.materialList = []
      postData = qs.stringify(postData)
      var url = '/set/settb109/select_material'
      this.axios
        .post(url, postData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(res => {
          if (res.data.code == 200) {
            this.materialList = res.data.data
            // this.materialValue = this.detailsList.ORMTB440CC01
            if (this.detailsList.ORMTB470CA18) {
              this.materialValue = this.detailsList.ORMTB470CA18
            } else {
              this.materialValue = this.detailsList.ORMTB470CA06
              // console.log(this.detailsList)
              this.queryMaterialPrice(this.materialValue)
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    //初始化数据
    init() {
      this.startTime = this.historyInfo.startTime
      this.endTime = this.historyInfo.endTime
      this.date = [this.startTime, this.endTime]
      this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
      this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
      this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
      this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
      this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
      this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
      this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
      this.currentPage = this.historyInfo.currentPage
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
      this.dateNowDayActive = this.historyInfo.dateNowDayActive
      this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
      this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
      this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
      this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
    },
    // 导出
    exports() {
      // console.log(this.uobj)
      let token = sessionStorage.getItem('token')
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        this.customerMo = this.uobj.ormtb410.ORMTB410ID //一级企业id
      }
      var startTime = this.date[0] //开始时间
      var endTime = this.date[1] //结束时间
      var ORMTB440CA02 = this.customerMo //二级客户ID
      var ORMTB400CA03 = 1002 //一级客户代码
      var ORMTB440CA04 = this.enterpriseTwo //二级企业ID
      var ORMTB440CA06 = this.materielMo //物料ID
      var ORMTB440CF01 = this.SETTB122CA07 //状态
      var ORMTB440CA00 = this.ORMTB440CA00 //订单号
      var ORMTB440CA01 = this.carNumber //车牌号
      var ORMTB470CA40 = this.ORMTB470CA40 //发单人
      var ORMTB410CA04 = this.ORMTB410CA04 //货主
      var ORMTB470CA58 = this.ORMTB470CA58 //运费结算方式
      var timeType = this.timeType //
	  var source = this.orderSource//订单出处
      var url =
        this.axios.defaults.baseURL +
        '/exc/toExcel/ormtb470toExcle?startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&token=' +
        token +
        '&ORMTB440CA02=' +
        ORMTB440CA02 +
        '&ORMTB400CA03=' +
        ORMTB400CA03 +
        '&ORMTB440CA04=' +
        ORMTB440CA04 +
        '&ORMTB440CA06=' +
        ORMTB440CA06 +
        '&ORMTB440CF01=' +
        ORMTB440CF01 +
        '&ORMTB440CA00=' +
        ORMTB440CA00 +
        '&ORMTB440CA01=' +
        ORMTB440CA01 +
        '&ORMTB470CA40=' +
        ORMTB470CA40 +
        '&ORMTB410CA04=' +
        ORMTB410CA04 +
        '&ORMTB470CA58=' +
        ORMTB470CA58 +'&source='+source+
        '&timeType=' +
        timeType
      window.location.href = url

      this.loadingBut = true
      var timer = null //倒计时
      this.confirmTxt = 30 - 1
      timer = setInterval(() => {
        if (this.confirmTxt === 0) {
          this.confirmTxt = ''
          this.loadingBut = false
          clearInterval(timer)
        } else {
          this.confirmTxt--
        }
      }, 1000)
    },
    topWeightInput() {
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /[^\d.]/g,
        ''
      ) //清除“数字”和“.”以外的字符
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /^\./g,
        ''
      ) //验证第一个字符是数字
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /\.{2,}/g,
        '.'
      ) //只保留第一个. 清除多余的
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        '.',
        '$#$'
      )
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      ) //只能输入两个小数
      if (
        this.detailsList.ORMTB440CE02.indexOf('.') < 0 &&
        this.detailsList.ORMTB440CE02 != ''
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.detailsList.ORMTB440CE02 = parseFloat(
          this.detailsList.ORMTB440CE02
        )
      }
      this.$refs.topWeight.value = this.detailsList.ORMTB440CE02
    },
    topWeightChange() {
      var index = String(this.detailsList.ORMTB440CE02).indexOf('.')
      if (index == -1) return
      var numArr = this.detailsList.ORMTB440CE02.split('.')
      if (numArr[1].length == 0) {
        this.$refs.topWeight.value = numArr[0]
        this.detailsList.ORMTB440CE02 = numArr[0]
      } else {
        this.$refs.topWeight.value = numArr[0] + '.' + numArr[1]
        this.detailsList.ORMTB440CE02 = numArr[0] + '.' + numArr[1]
      }
    },
    topMoneyInput() {
      //充值金额实时校验
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /[^\d.]/g,
        ''
      ) //清除“数字”和“.”以外的字符
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /^\./g,
        ''
      ) //验证第一个字符是数字
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /\.{2,}/g,
        '.'
      ) //只保留第一个. 清除多余的
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        '.',
        '$#$'
      )
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      ) //只能输入两个小数
      if (
        this.detailsList.ORMTB440CA21.indexOf('.') < 0 &&
        this.detailsList.ORMTB440CA21 != ''
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.detailsList.ORMTB440CA21 = parseFloat(
          this.detailsList.ORMTB440CA21
        )
      }
      this.$refs.topMoney.value = this.detailsList.ORMTB440CA21
    },
    topMoneyChange() {
      //充值金额失去焦点数据处理
      var index = String(this.detailsList.ORMTB440CA21).indexOf('.')
      if (index == -1) return
      var numArr = this.detailsList.ORMTB440CA21.split('.')
      if (numArr[1].length == 0) {
        this.$refs.topMoney.value = numArr[0]
        this.detailsList.ORMTB440CA21 = numArr[0]
      } else {
        this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
        this.detailsList.ORMTB440CA21 = numArr[0] + '.' + numArr[1]
      }
    },
    returnReceiptserve() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB440CE07: this.uobj.pertb005.pertb005id, //开始时间
        ORMTB440CE08: this.uobj.pertb005.pertb005ca02,
        ORMTB440CE09: this.detailsList.ORMTB440CE02,
        ORMTB440ID: this.detailsList.ORMTB440ID,
        ORMTB440CA21: this.detailsList.ORMTB440CA21,
      }
      this.tableData = []
      var url = '/orm/ormtb440/ormtb440Confirm'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '确认回执成功',
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    djcancelOrder(row, datadj) {
      console.log(row)
      var url = '/orm/ormtb470/updateStatus'
      this.$prompt('请输入原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB470ID: row.ORMTB470ID,
          ORMTB470CA62: datadj, //状态
          ORMTB470CA63: value, //冻结解冻原因
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.axios
          .post(url, postData)
          .then(res => {
            if (res.data.code == 200) {
              this.pageList()
              this.$message({
                type: 'success',
                message: '成功!',
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
            loading.close()
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    // 取消订单
    cancelOrder(row) {
      var url = '/orm/ormtb470/updateORMTB470CD00'
      this.$prompt('请输入取消原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB470ID: row.ORMTB470ID,
          // ORMTB440CF01: -1, //状态
          ORMTB470CA29: value, //取消原因
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.axios
          .post(url, postData)
          .then(res => {
            if (res.data.code == 200) {
              this.pageList()
              this.$message({
                type: 'success',
                message: '取消成功!',
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
            loading.close()
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    materielMoPost() {
      var i = (this.enterpriseTwoOptionList || []).findIndex(
        profile => profile.SETTB99ID === this.enterpriseTwo
      )
      var url = '/set/settb109/selectPageList'
      var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
      var data = {
        SETTB109CA03: '',
        SETTB109CA00: '',
        SETTB109CD01: SETTB100ID,
        SETTB99ID: this.enterpriseTwo,
        page: 1,
        limit: 1000,
      }
      var List = [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ]
      this.axios.post(url, data).then(res => {
        if (res.data.code == 200) {
          this.materielOptions = [...List, ...res.data.data]
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    erpChange() {
      if (this.enterpriseTwo != '') {
        this.materielMoPost()
      } else {
        this.materielOptions = [
          {
            SETTB109CA00: '全部',
            SETTB109ID: '',
          },
        ]
      }
    },

    // 查询
    queryClick() {
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.pageList()
    },
    resetFilters() {
      this.enterpriseTwo = ''
      this.materielMo = ''
      this.SETTB122CA07 = ''
      this.ORMTB470CA58 = ''
      this.carNumber = ''
      this.lxorde = ''
      this.timeType = '1'
      this.xgorde = ''
      this.ORMTB470CA12 = ''
      this.ORMTB470CA40 = ''
      this.ORMTB410CA04 = ''
      this.cdorde = ''
      this.orderSource = ''
      this.pageMo = 1
      this.currentPage = 1
      this.getNowDay()
      this.queryClick()
    },
    // 列表
    pageList() {
      var ORMTB400CA03
      // console.log(this.uobj)
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        ORMTB400CA03 = this.uobj.ormtb410.ORMTB410ID
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
        ORMTB400CA03 = this.uobj.ormtb400.ORMTB400CA03
      }

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        startTime: this.startTime, //开始时间
        endTime: this.endTime, //结束时间
        ORMTB410ID: this.customerMo, //二级客户ID
        ORMTB470CA58: this.ORMTB470CA58,
        // ORMTB410CA03: ORMTB400CA03, //一级客户代码
        ORMTB470CA04: this.enterpriseTwo, //二级企业ID
        ORMTB470CA06: this.materielMo, //物料ID
        ORMTB470CD00: this.SETTB122CA07, //状态
        ORMTB470CA00: this.ORMTB440CA00, //订单号
        ORMTB470CA01: this.carNumber, //车牌号
        ORMTB470CA61: this.lxorde, //离线订单
        ORMTB470CN00: this.xgorde, //修改流水
		ORMTB440CN05: this.cdorde,//错单
        ORMTB470CA12: this.ORMTB470CA12,
        ORMTB470CA40: this.ORMTB470CA40,
        ORMTB410CA04: this.ORMTB410CA04,
        page: this.pageMo,
        limit: this.limitMo,
        timeType: this.timeType,
        dcmore: '',
		source:this.orderSource,//订单出处
		ORMTB470CN18: this.cdorde//错单
      }
      this.tableData = []
      var url = '/orm/ormtb470/selectPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          // console.log(res)
          if (res.data.code == 200) {
            var data = res.data.data.dataList
            // console.log(data)
            this.pagingPageMo = res.data.count
            for (var i = 0; i < data.length; i++) {
              var customerName = ''
              if (data[i]['ORMTB470CD00'] == '-1') {
                data[i]['ORMTB440CF01text'] = '取消'
              } else if (data[i]['ORMTB470CD00'] == '0') {
                data[i]['ORMTB440CF01text'] = '已接单'
              } else if (data[i]['ORMTB470CD00'] == '1') {
                data[i]['ORMTB440CF01text'] = '提货中'
              } else if (data[i]['ORMTB470CD00'] == '2') {
                data[i]['ORMTB440CF01text'] = '已出厂结算'
              } else if (data[i]['ORMTB470CD00'] == '3') {
                data[i]['ORMTB440CF01text'] = '待审核磅单'
              } else if (data[i]['ORMTB470CD00'] == '4') {
                data[i]['ORMTB440CF01text'] = '已审核待确认'
              } else if (data[i]['ORMTB470CD00'] == '5') {
                data[i]['ORMTB440CF01text'] = '已完成'
              } else if (data[i]['ORMTB470CD00'] == '-2') {
                data[i]['ORMTB440CF01text'] = '申请取消'
              } else if (data[i]['ORMTB470CD00'] == '-3') {
                data[i]['ORMTB440CF01text'] = '磅单审核已拒绝'
              }

              if (data[i]['ORMTB470CD00'] == '-2') {
                if (data[i]['ORMTB470CD01'] == '0') {
                  data[i]['auditText'] = '未审核'
                } else if (data[i]['ORMTB470CD01'] == '1') {
                  data[i]['auditText'] = '通过'
                } else if (data[i]['ORMTB470CD01'] == '2') {
                  data[i]['auditText'] = '拒绝'
                }
              }

              // else if (data[i]['ORMTB440CF01'] == '6') {
              // 	data[i]['auditText'] = '未审核'
              // }
              else {
                data[i]['auditText'] = '通过'
                // if (data[i].ORMTB440CH00 == 0) {
                // 	data[i].isauditOrder = 0
                // }
                // if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 0) {
                // 	data[i].isauditOrder = 1
                // }
                // if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 1) {
                // 	data[i].isauditOrder = 0
                // }
                // if (data[i]['ORMTB440CH01'] == '0') {
                // 	data[i]['auditText'] = '未审核'
                // } else if (data[i]['ORMTB440CH01'] == '1') {
                // 	data[i]['auditText'] = '通过'
                // } else if (data[i]['ORMTB440CH01'] == '2') {
                // 	data[i]['auditText'] = '拒绝'
                // }
              }
            }
            this.tableData = data
            this.jscc = res.data.data.jscc
            this.jsje = res.data.data.jsje
            this.jszl = res.data.data.jszl
            this.jsyf = res.data.data.jsyf

            this.pdcc = res.data.data.pdcc
            this.pdje = res.data.data.pdje
            this.pdzl = res.data.data.pdzl
            this.pdyf = res.data.data.pdyf

            this.wccc = res.data.data.wccc
            this.wcje = res.data.data.wcje
            this.wcyf = res.data.data.wcyf
            this.jsyfsjtj = res.data.data.wcjsyf
            this.glf = res.data.data.fwf
            this.wczl = res.data.data.wczl
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    UploadClick(row) {
      this.ORMTB470CA00 = row.ORMTB470ID
      this.$nextTick(() => {
        if (this.$refs.freightUploadInput) {
          this.$refs.freightUploadInput.value = ''
          this.$refs.freightUploadInput.click()
        }
      })
    },
    handleFreightRowClick(row, column, event) {
      const target = event && event.target
      if (
        target &&
        target.closest &&
        target.closest('.el-button, .el-dropdown, .el-table__expand-icon')
      ) {
        return
      }
      if (this.$refs.freightTable) {
        this.$refs.freightTable.toggleRowExpansion(row)
      }
    },
    handleFreightOrderAction(command, row) {
      if (command == 'qrCode') {
        this.ewmDetailsClick(row)
      } else if (command == 'freeze') {
        this.djcancelOrder(row, 1)
      } else if (command == 'unfreeze') {
        this.djcancelOrder(row, 0)
      } else if (command == 'cancelPlan') {
        this.cancelPlan(row)
      } else if (command == 'auditCancel') {
        this.isorderAudit(row)
      } else if (command == 'auditWeight') {
        this.orderAudit(row)
      } else if (command == 'writeOffWeight') {
        this.orderAudit1(row, 'hx')
      } else if (command == 'uploadWeight') {
        this.orderAudit2(row)
      } else if (command == 'auditDispatch') {
        this.isorderAudit(row)
      } else if (command == 'receipt') {
        this.returnReceipt(row)
      } else if (command == 'uploadQr') {
        this.UploadClick(row)
      } else if (command == 'completeFactory') {
        this.inputWeightClick(row)
      } else if (command == 'mistakeOrder') {
        this.cdclDetailsClick(row)
      }
    },
    ewmDetailsClick(row) {
      // console.log(row)
      this.ewmDetilsShow = true
      this.queryermdetile(row)
    },
    inputFileChange(e) {
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      formData.append('ORMTB470ID', this.ORMTB470CA00)
      let loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb470/upload'
      this.axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '上传成功',
              type: 'success',
            })
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    inputWeightClick(row) {
      console.log(row)
      //
      this.inputWeightShow = true
      if (row.ORMTB470CA04 == '10000108') {
        this.dcjsiput = false
      } else {
        this.dcjsiput = true
      }

      this.orderId = row.ORMTB470CA04
      this.newOrderId = row.ORMTB470ID
      this.querydetile(row)
      this.getSelectMaterial(row)

      this.fileListccbd = []
    },
    inputWeightClose() {
      this.weightOpt.tare = ''
      // this.weightOpt.gross = ''
      // this.detailsList.ORMTB440CC02 = ''
      // this.detailsList.ORMTB440CC02 = ''
      // this.detailsList.ORMTB470CA21 = ''
      this.weightOpt.jsprice = ''
    },
    // 获取结算金额
    async getSettlementAmount() {
      // console.log(typeof this.weightOpt.tare)
      if (!this.materialValue) return
      if (this.weightOpt.price < 0) return
      if (this.weightOpt.tare === '') return

      var params = {
        ORMTB440CC01: this.materialValue,
        ORMTB440CA02: this.detailsList.ORMTB410CA01,
        ORMTB440CA04: this.detailsList.ORMTB470CA04,
        ORMTB440CC03: this.detailsList.ORMTB470CA20,
        ORMTB440CC04: this.weightOpt.tare,
        ORMTB440CC03: this.weightOpt.price,
      }
      params = qs.stringify(params)

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb440/orderCompleteBeforeBack'
      this.axios
        .post(url, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.weightOpt.jsprice = res.data.data
            // this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    inputWeightConfirm() {
      var {
        ORMTB470ID, // 派单记录ID - 隐藏

        // ORMTB470CA23, // 结算金额 -可修改
      } = this.detailsList
      var ORMTB470CA18 = this.materialValue // 物料id
      var ORMTB470CA19 = this.materialList.find(
        em => em.value === this.materialValue
      ).lable // 结算物料 -可修改
      var {
        tare, // 结算重量 -不修改
      } = this.weightOpt
      if (!tare) {
        return this.$message({
          message: '请输入净重',
          type: 'error',
        })
      }

      if (
        this.detailsList.ORMTB470CA04 == '10000106' ||
        this.detailsList.ORMTB470CA66 == '1'
      ) {
        if (this.ruleForm.csAvatar == '') {
          return this.$message({
            message: '请上传出厂磅单',
            type: 'error',
          })
        }
      }

      if (this.orderId == '10000106' || this.orderId == '10000155') {
        this.dcmore = this.weightOpt.price
      } else {
        this.dcmore = ''
      }
      // if (!gross) {
      // 	return this.$message({
      // 		message: '请输入皮重',
      // 		type: 'error'
      // 	});
      // }
      var params = {
        ORMTB470ID,
        ORMTB470CA18, // 物料id
        ORMTB470CA19: ORMTB470CA19,
        ORMTB470CA21: tare,
        ORMTB470CA67: this.ruleForm.csAvatar,
		fileId: this.ruleForm.fileId,
        //ORMTB440CC03: this.weightOpt.price,
        ORMTB470CA20: this.dcmore,
      }
      params = qs.stringify(params)

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb470/update'
      this.axios
        .post(url, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.tableData = []
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            this.inputWeightShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    inputWeightFormat(e, type, type2) {
      console.log('type', type, type2)
      let value = e.target.value
      // console.log(value)
      // console.log(type)
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/^\./g, '') //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      this.weightOpt.tare = value
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }
      this.weightOpt[type] = value

      if (type2 == 'hx') {
        this.getFree() //获取结算运费
      }
    },
    inputWeightFormat1(e, type, type2) {
      let value = e.target.value
      // console.log(value)
      // console.log(type)
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/^\./g, '') //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }

      this.$set(this.weightOpt, 'price', value)

      if (type2 == 'hx') {
        this.getFree() //获取结算运费
      }
    },
    inputWeightTotalFormat(e) {
      let value = e.target.value
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/^\./g, '') //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }
      this.weightOpt.jsprice = value
    },
    // 详情
    DetailsClick(row) {
      this.oerderDetilsShow = true
      this.querydetile(row, null, false)
    },
    orderAudit(row) {
      this.orderAuditShow = true
      this.examineObj = row
      this.querydetile(row)
    },
    orderAudit1(row, type) {
      this.orderAuditShow1 = true
      this.examineObj = row
      this.querydetile(row, type)
    },
    orderAudit2(row) {
      this.orderAuditShow2 = true
      this.examineObj = row
      // console.log(this.examineObj)
	    // console.log(this.formData.fileList)
		this.formData.fileList = []
      this.querydetile(row)
    },
    isorderAudit(row) {
      this.isorderAuditShow = true
      this.querydetile(row)
    },
    returnReceipt(row) {
      this.returnReceiptShow = true
      this.querydetile(row)
    },
    examineOrder() {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB470ID: this.examineObj.ORMTB470ID,
        ORMTB470CA48: this.detailsList.ORMTB470CA48,
      }
      this.tableData = []
      var url = '/orm/ormtb470/examine'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.orderAuditShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    examineWriteOffOrder() {
      if(this.detailsList.ORMTB470CA52 < this.detailsList.ORMTB470CA14){
        return this.$message({
          message: '发单运费不能低于接单运费',
          type: 'warning',
        })
      }
      //核销磅单
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB470ID: this.examineObj.ORMTB470ID,
        ORMTB470CC05: this.detailsList.ORMTB470CC05,
        ORMTB470CA14: this.detailsList.ORMTB470CA14,
        ORMTB470CA33: this.detailsList.ORMTB470CA33,
        ORMTB470CA72: this.detailsList.ORMTB470CA72,
        ORMTB470CA52: this.detailsList.ORMTB470CA52,
      }
      this.tableData = []
      var url = '/orm/ormtb470/complete'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '成功',
              type: 'success',
            })
            this.orderAuditShow1 = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    examinebdOffOrder() {
      //上传磅单

      // console.log(this.detailsList.ph)
      if (this.detailsList.ph == '' || this.detailsList.ph == undefined) {
        this.$message({
          message: '请输入票号',
          type: 'error',
        })
        return
      }
      if (this.detailsList.ORMTB470CC05 == '') {
        this.$message({
          message: '请输入卸货重量',
          type: 'error',
        })
        return
      }

      // this.formData.fileList.push({
      // 	url: this.dialogImageUrl

      // });

      // this.formData.fileList.push(this.dialogImageUrl)
      // console.log(this.formData.fileList)
      // console.log(this.dialogImageUrl)

      if (this.formData.fileList.length <= 0) {
        this.$message({
          message: '请上传磅单',
          type: 'error',
        })
        return
      }
      // if (this.dialogImageUrl=='') {
      // 	this.$message({
      // 		message: '请上传磅单',
      // 		type: 'error'
      // 	});
      // 	return
      // }

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB470ID: this.examineObj.ORMTB470ID,
        ORMTB470CA35: this.formData.fileList[0].url,
		fileId:this.formData.fileId,
        ORMTB470CA48: this.detailsList.ph,
        ORMTB470CC05: this.detailsList.ORMTB470CC05,
      }
      var url = '/orm/ormtb470/confirm'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.orderAuditShow2 = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    queryermdetile(row) {
      var postData = {
        ORMTB470ID: row.ORMTB470ID, //流水id
      }
      this.detailsList = ''
      var url = '/orm/ormtb470/getErwei'
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {
          console.log(res)
          this.ewmdetailsList = res.data.data
          this.ewmdetailsList.ORMTB440CA22Img =
            'data:image/png;base64,' + res.data.data.ORMTB470CA30
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    updateOrder() {
      var url = '/orm/ormtb470/updateORMTB470CA44'
      this.$prompt('请输入原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB470CA44: value,
          ORMTB470ID: this.examineObj.ORMTB470ID,
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.tableData = []
        this.axios
          .post(url, postData)
          .then(res => {
            setTimeout(() => {
              loading.close()
            }, 400)
            if (res.data.code == 200) {
              this.$message({
                message: '审核成功',
                type: 'success',
              })
              this.orderAuditShow = false
              this.pageList()
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    orderAuditServe(type) {
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB440CG00: type,
        ORMTB440CG02: this.uobj.pertb005.pertb005ca02,
        ORMTB440ID: this.detailsList.ORMTB440ID,
        ORMTB440CA02: this.detailsList.ORMTB440CA02,
        ORMTB440CA11: this.detailsList.ORMTB440CA11,
        ORMTB440CA12: this.detailsList.ORMTB440CA12,
      }
      this.tableData = []
      var url = '/orm/ormtb440/updateORMTB440CG00'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.orderAuditShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    isorderAuditServe(type) {
      // console.log(type)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var postData = {
        ORMTB470CD01: type,
        ORMTB470ID: this.detailsList.ORMTB470ID,
        ORMTB470CA44: this.isorderAuditText,
      }
      this.tableData = []
      var url = '/orm/ormtb470/updateORMTB470CD01NEW'
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.isorderAuditShow = false
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    querydetile(row, type, loadMaterial = true) {
      var postData = {
        ORMTB470ID: row.ORMTB470ID, //流水id
      }
      this.detailsList = ''
      var url = '/orm/ormtb470/selectDetails'
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {
          this.detailsList = res.data.data

          this.weightOpt.price = this.detailsList.ORMTB470CA08

          this.dialogVisible = true
          this.dialogImageUrl = this.detailsList.ORMTB470CA35
          this.bdurlList.push(this.detailsList.ORMTB470CA35)

          if (this.detailsList.ORMTB470CA35)
            this.DetailsWeightrcList = [this.detailsList.ORMTB470CA35]

          if (loadMaterial && row.ORMTB470CD00 == 0 && row.ORMTB470CA30) {
            this.weightOpt.tare = 0
            this.getSelectMaterial(row)
          }
          if (type == 'hx') {
            this.getFree() //获取结算运费
          }
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities : []
      this.isIndeterminate = false
      this.tableHeadList = val ? this.tableHeadListInit : []
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length
      var changearr = this.checkedCities
      var initarr = this.tableHeadListInit
      this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr)
    },

    dateFtt(fmt, date) {
      //author: meizz
      var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      }
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
      return fmt
    },

    //获取当前时间
    getNowDay() {
      var date = new Date().getTime()
      var Ming = new Date().getTime() + 24 * 60 * 60 * 1000
      var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
      var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
      data = `${data} ${this.exchangeTiem || '00:00:00'}`
      enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
      this.date = [enddata, data]
      this.dateNowDayActive = true
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    datePickerChange(e) {
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取昨天时间
    getYesterday() {
      var hms = new Date().getTime() - 24 * 60 * 60 * 1000
      var Ming = new Date().getTime()
      var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
      var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
      nowDay = `${nowDay} ${this.exchangeTiem || '00:00:00'}`
      enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
      this.date = [nowDay, enddata]
      this.dateNowDayActive = false
      this.dateYesterdayActive = true
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取当月时间
    sameMonth() {
      var date = new Date()
      var hms = date.setDate(1)
      var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
      firstDay = `${firstDay} ${this.exchangeTiem || '00:00:00'}`
      var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000
      var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate))
      nextDay = `${nextDay} ${this.exchangeTiem || '00:00:00'}`
      this.date = [firstDay, nextDay]
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = true
      this.dateLastMonthActive = false
    },
    //获取上月时间
    lastMonth() {
      var nowdays = new Date()
      var year = nowdays.getFullYear()
      var month = nowdays.getMonth()
      var lastyear = year
      var lastmonth = month
      if (month == 0) {
        month = 12
        year = year - 1
      }
      if (month == 12) {
        lastmonth = 1
      } else {
        lastmonth = lastmonth + 1 * 1
      }
      if (month < 10) {
        month = '0' + month
      }
      if (lastmonth < 10) {
        lastmonth = '0' + lastmonth
      }
      var firstDayOfPreMonth = year + '-' + month + '-' + '01'
      var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem ||
        '00:00:00'}`
      // var lastDay = new Date(lastyear, lastmonth, 0);
      let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this
        .exchangeTiem || '00:00:00'}`
      this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = true
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.limitMo = val
      this.pageList()
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.pageList()
    },
  },
}
</script>

<style scoped>
.DWD-li {
  display: flex;
  min-height: 42px;
  box-sizing: border-box;
  border: 1px solid #d8e5f2;
  border-radius: 10px;
  font-size: 14px;
  color: #31465c;
  background: #fff;
  overflow: hidden;
}

.DWD-li > div {
  min-height: 42px;
  padding: 9px 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

.DWD-li-title {
  flex: 0 0 132px;
  justify-content: center;
  text-align: center;
  border-right: 1px solid #e4edf6;
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.12), rgba(24, 144, 255, 0.04));
  color: #4b6784;
  font-weight: 600;
}

.DWD-li-text {
  flex: 1;
  min-width: 0;
  word-break: break-all;
  color: #24384d;
}

.DWD-li-text input {
  width: 100%;
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  font-size: 14px;
  border: 1px solid #d7e5f3;
  border-radius: 8px;
  outline: none;
  background: #f8fbff;
  box-sizing: border-box;
}

.DWD-li + .DWD-li {
  margin-top: 10px;
}

.DWD-table {
  display: flex;
  border: 1px solid #d8e5f2;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.DWD-table-left-flex {
  flex: 1;
}

.DWD-table > div > div {
  min-height: 40px;
  padding: 8px 10px;
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #e4edf6;
  border-bottom: 1px solid #e4edf6;
  box-sizing: border-box;
  color: #31465c;
}

.DWD-table > div > div:first-child {
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.12), rgba(24, 144, 255, 0.04));
  color: #4b6784;
  font-weight: 600;
}

.DWD-table-left-title > div {
  width: 101px;
  text-align: center;
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.12), rgba(24, 144, 255, 0.04));
}

.DWD-table .DWD-table-left-title > div {
  min-height: 40px;
  padding: 8px 10px;
  overflow: hidden;
  box-sizing: border-box;
  border-left: 1px solid #e4edf6;
  border-bottom: 1px solid #e4edf6;
  color: #4b6784;
  font-weight: 600;
}

.DetailsWater-img {
  margin-top: 18px;
}

.DetailsWater-img-text {
  display: inline-block;
  width: 101px;
  text-align: center;
  vertical-align: top;
}

.car-number-add {
  /* text-transform: uppercase; */
}

.billOperationRecord-table {
  padding: 30px 20px 0;
}

.public_singleMenu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
  background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
  flex: 1.5;
}

.fontBlue {
  color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
  height: 45px;
  align-items: center;
}

.billOperationRecord {
  background-color: #f3f3f3;
}

.billOperationRecord th,
.billOperationRecord td {
  text-align: center !important;
}

/* 统计 START*/
.imgStatistics {
  width: 40px;
  height: 40px;
}

.payType {
  /* font-size: 15px; */
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  line-height: 26px;
}

.singular {
  /* font-size: 14px; */
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  vertical-align: middle;
  padding-left: 10px;
}

.Amount {
  /* font-size: 14px; */
  font-family: Microsoft YaHei;
  /* font-weight:bold; */
  line-height: 30px;
  vertical-align: middle;
  padding-left: 10px;
}

.pulic_statistics_titlt {
  line-height: 40px;
  /* font-size: 14px; */
}

.billDetails-statistics {
  justify-content: space-around;
}

.public_statisticsInfo {
  margin-top: 5px;
  margin-bottom: 10px;
}

.billOperationRecord .freight-stat-shell {
  position: relative;
  padding: 16px;
  border: 1px solid rgba(202, 220, 238, 0.9);
  border-radius: 16px;
  background:
    radial-gradient(circle at 0 0, rgba(8, 214, 145, 0.1), transparent 220px),
    radial-gradient(circle at 100% 0, rgba(25, 159, 255, 0.1), transparent 240px),
    linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
  box-shadow: 0 12px 30px rgba(36, 93, 150, 0.09);
}

.billOperationRecord .freight-stat-hint {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  margin: 0 0 12px;
}

.billOperationRecord .freight-stat-hint span {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 0 10px;
  border: 1px solid #dceafb;
  border-radius: 999px;
  background: rgba(247, 251, 255, 0.9);
  color: #5c7894;
  font-size: 12px;
  line-height: 22px;
}

.billOperationRecord .freight-stat-hint span::before {
  content: '';
  width: 5px;
  height: 5px;
  margin-right: 6px;
  border-radius: 50%;
  background: #199fff;
}


.billOperationRecord .freight-stat-panel {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.billOperationRecord .freight-stat-group {
  min-width: 0;
  padding: 14px;
  border: 1px solid rgba(211, 226, 240, 0.95);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.78);
}

.billOperationRecord .freight-stat-group-money {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(246, 255, 251, 0.88) 100%);
}

.billOperationRecord .freight-stat-group-operate {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(247, 251, 255, 0.88) 100%);
}

.billOperationRecord .freight-stat-group-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;
  padding: 0 2px 10px;
  border-bottom: 1px solid rgba(220, 234, 247, 0.9);
}

.billOperationRecord .freight-stat-group-title span {
  display: inline-flex;
  align-items: center;
  color: #20364d;
  font-size: 15px;
  font-weight: 900;
}

.billOperationRecord .freight-stat-group-title span::before {
  content: '';
  width: 7px;
  height: 7px;
  margin-right: 7px;
  border-radius: 50%;
  background: #199fff;
}

.billOperationRecord .freight-stat-group-money .freight-stat-group-title span::before {
  background: #08d691;
}

.billOperationRecord .freight-stat-group-title em {
  color: #7a8da0;
  font-style: normal;
  font-size: 12px;
  white-space: nowrap;
}

.billOperationRecord .freight-stat-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.billOperationRecord .freight-stat-card {
  position: relative;
  min-width: 0;
  padding: 16px;
  border: 1px solid #e0ebf6;
  border-radius: 14px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  overflow: hidden;
  transition: border-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.billOperationRecord .freight-stat-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 4px;
  background: #199fff;
}

.billOperationRecord .freight-stat-card:hover {
  border-color: #b7d8f4;
  box-shadow: 0 10px 22px rgba(40, 95, 150, 0.1);
  transform: translateY(-2px);
}

.billOperationRecord .freight-stat-card-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.billOperationRecord .freight-stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #eaf5ff;
}

.billOperationRecord .freight-stat-icon img {
  width: 24px;
  height: 24px;
}

.billOperationRecord .freight-stat-title,
.billOperationRecord .freight-stat-desc {
  margin: 0;
}

.billOperationRecord .freight-stat-title {
  color: #1e344c;
  font-size: 15px;
  font-weight: 900;
  line-height: 20px;
}

.billOperationRecord .freight-stat-desc {
  margin-top: 3px;
  color: #8a9bad;
  font-size: 12px;
  line-height: 16px;
}

.billOperationRecord .freight-stat-main {
  margin-bottom: 12px;
  padding: 12px;
  border-radius: 12px;
  background: #f2f8ff;
  cursor: help;
}

.billOperationRecord .freight-stat-main:hover,
.billOperationRecord .freight-stat-subgrid > .el-tooltip:hover > div {
  outline: 1px solid rgba(25, 159, 255, 0.28);
  outline-offset: 2px;
}

.billOperationRecord .freight-stat-main span,
.billOperationRecord .freight-stat-subgrid span {
  display: block;
  color: #8798aa;
  font-size: 12px;
  line-height: 16px;
}

.billOperationRecord .freight-stat-main strong {
  display: block;
  margin-top: 6px;
  color: #153250;
  font-size: 24px;
  font-weight: 900;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.billOperationRecord .freight-stat-subgrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.billOperationRecord .freight-stat-subgrid > div,
.billOperationRecord .freight-stat-subgrid > .el-tooltip > div {
  min-width: 0;
  padding: 9px 10px;
  border: 1px solid #edf3f9;
  border-radius: 10px;
  background: #fff;
  cursor: help;
}

.billOperationRecord .freight-stat-subgrid strong {
  display: block;
  margin-top: 5px;
  color: #263c54;
  font-size: 15px;
  font-weight: 900;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.billOperationRecord .freight-stat-card-money::before,
.billOperationRecord .freight-stat-card-freight::before {
  background: linear-gradient(90deg, #08d691, #46e0ad);
}

.billOperationRecord .freight-stat-card-count::before {
  background: linear-gradient(90deg, #199fff, #69bdff);
}

.billOperationRecord .freight-stat-card-weight::before {
  background: linear-gradient(90deg, #ff7a45, #ffb06d);
}

.billOperationRecord .freight-stat-card-money .freight-stat-icon,
.billOperationRecord .freight-stat-card-freight .freight-stat-icon {
  background: #e8fbf4;
}

.billOperationRecord .freight-stat-card-count .freight-stat-icon {
  background: #eaf5ff;
}

.billOperationRecord .freight-stat-card-weight .freight-stat-icon {
  background: #fff2e9;
}

.billOperationRecord .freight-stat-card-money .freight-stat-main,
.billOperationRecord .freight-stat-card-freight .freight-stat-main {
  background: #effbf6;
}

.billOperationRecord .freight-stat-card-count .freight-stat-main {
  background: #f0f8ff;
}

.billOperationRecord .freight-stat-card-weight .freight-stat-main {
  background: #fff6ef;
}

.input_ {
  display: flex;
  height: 2.34vw;
  line-height: 2vw;
}

::v-deep .el-input__inner {
  /* width: 7.083vw; */
  height: 1.7vw;
}

:v-deep .el-input {
  width: unset;
}

/* 统计 END*/

.billOperationRecord {
  min-height: 100%;
  padding: 16px 18px 22px;
  background:
    radial-gradient(circle at 0 0, rgba(25, 159, 255, 0.1), transparent 260px),
    linear-gradient(180deg, #f4f8fc 0%, #eef3f8 100%);
}

.billOperationRecord .dispatch-filter-card,
.billOperationRecord .public_statisticsInfo,
.billOperationRecord .billOperationRecord-table {
  border: 1px solid rgba(202, 220, 238, 0.9);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 28px rgba(36, 93, 150, 0.08);
}

.billOperationRecord .dispatch-filter-card {
  padding: 16px 22px 18px;
  margin-bottom: 10px;
}

.billOperationRecord .dispatch-section-wrap {
  width: 100%;
  margin-bottom: 10px;
}

.billOperationRecord .dispatch-section-head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px 16px;
  margin-bottom: 10px;
  padding-left: 14px;
}

.billOperationRecord .dispatch-section-head::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 4px;
  height: 22px;
  border-radius: 4px;
  transform: translateY(-50%);
  background: linear-gradient(180deg, #199fff 0%, #08d691 100%);
}

.billOperationRecord .dispatch-section-title {
  margin: 0;
  color: #20364d;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
}

.billOperationRecord .dispatch-section-desc {
  margin: 6px 0 0;
  color: #7a8da0;
  font-size: 13px;
  line-height: 20px;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px 18px;
  padding: 14px 16px;
  border-radius: 10px;
  background: #f8fbfe;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange .public_oparetionBlock_Menu {
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  margin-right: 0;
  margin-bottom: 0;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange .public_lbSty {
  flex: 0 0 92px;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange .public_optionSty,
.billOperationRecord .dispatch-filter-card > .public_criteriaRange .el-select,
.billOperationRecord .dispatch-filter-card > .public_criteriaRange .el-input {
  flex: 1;
  min-width: 0;
  width: auto;
  margin-right: 0;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange .pulic_carNumber {
  width: 100%;
}

.billOperationRecord .dispatch-date-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
  margin-top: 12px;
  padding: 12px 16px;
  border: 1px solid #eaf1f8;
  border-radius: 10px;
  background: #fbfdff;
}

.billOperationRecord .dispatch-date-label {
  color: #4d6985;
  font-size: 13px;
  font-weight: 700;
}

.billOperationRecord .dispatch-date-row .public_operatArea_timePicker {
  margin-left: 0;
}

.billOperationRecord .dispatch-operat-btn {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.billOperationRecord .dispatch-operat-btn .el-button,
.billOperationRecord .dispatch-operat-btn button {
  margin-left: 0;
}

.billOperationRecord .dispatch-reset-btn {
  border-color: #f3b25f;
  color: #b96b12;
  background: linear-gradient(180deg, #fffaf2 0%, #fff3df 100%);
  font-weight: 600;
  box-shadow: 0 6px 14px rgba(185, 107, 18, 0.14);
}

.billOperationRecord .dispatch-reset-btn:hover,
.billOperationRecord .dispatch-reset-btn:focus {
  border-color: #e5962f;
  color: #9b570b;
  background: #ffefd4;
}

.billOperationRecord .dispatch-reset-btn .el-icon-refresh-left {
  margin-right: 4px;
  font-weight: 700;
}

.billOperationRecord .public_statisticsInfo {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 12px;
  height: auto;
  padding: 18px;
}

.billOperationRecord .billDetails-statistics {
  display: flex;
  align-items: center;
  flex: 1 1 280px;
  min-height: 112px;
  height: auto;
  margin-right: 0 !important;
  padding: 16px 18px;
  border: 1px solid #edf3f9;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbfe 100%);
}

.billOperationRecord .billDetails-statistics .public_statisticsContent {
  display: flex;
  flex: 0 0 72px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.billOperationRecord .billDetails-statistics .billDetails-ul {
  flex: 1;
  min-width: 0;
  margin: 0 0 0 18px !important;
  padding: 0;
}

.billOperationRecord .billDetails-statistics .pulic_statistics_titlt {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 10px;
  line-height: 1.5;
}

.billOperationRecord .billOperationRecord-table {
  padding: 18px 20px 0;
}

.billOperationRecord .dispatch-table-head {
  margin-bottom: 10px;
}

.billOperationRecord .dispatch-table-tools {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-left: auto;
}

.billOperationRecord .dispatch-table-tip,
.billOperationRecord .dispatch-table-meta {
  color: #7a8da0;
  font-size: 13px;
}

.billOperationRecord /deep/ .el-table {
  border-radius: 10px;
  overflow: hidden;
}

.billOperationRecord /deep/ .el-table td {
  border-bottom-color: #edf3f9;
}

.billOperationRecord /deep/ .el-table__row:hover > td {
  background-color: #f4faff !important;
}

.billOperationRecord .dispatch-cell-main,
.billOperationRecord .dispatch-cell-sub {
  margin: 0;
}

.billOperationRecord .dispatch-cell-main {
  color: #1e334a;
  font-size: 15px;
  font-weight: 800;
  line-height: 21px;
}

.billOperationRecord .dispatch-cell-sub {
  color: #7b8fa4;
  font-size: 12px;
  line-height: 18px;
}

.billOperationRecord .dispatch-cell-block {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.billOperationRecord .dispatch-cell-block-compact {
  padding: 2px 0;
}

.billOperationRecord .dispatch-expand-panel {
  padding: 18px;
  border-left: 4px solid #1890ff;
  background: linear-gradient(135deg, #f8fbff 0%, #eef6ff 100%);
}

.billOperationRecord .dispatch-expand-section {
  padding: 14px;
  border: 1px solid #dceafb;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.72);
}

.billOperationRecord .dispatch-expand-section + .dispatch-expand-section {
  margin-top: 14px;
}

.billOperationRecord .dispatch-expand-title {
  position: relative;
  margin-bottom: 12px;
  padding-left: 12px;
  color: #1f456b;
  font-size: 15px;
  font-weight: 800;
}

.billOperationRecord .dispatch-expand-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 4px;
  width: 4px;
  height: 14px;
  border-radius: 4px;
  background: #1890ff;
}

.billOperationRecord .dispatch-expand-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
}

.billOperationRecord .dispatch-expand-item {
  min-height: 58px;
  padding: 10px 12px;
  border: 1px solid #e2edf8;
  border-radius: 10px;
  background: #fff;
  box-sizing: border-box;
  box-shadow: 0 6px 16px rgba(53, 97, 145, 0.06);
}

.billOperationRecord .dispatch-expand-item span {
  display: block;
  margin-bottom: 7px;
  color: #7f91a5;
  font-size: 12px;
}

.billOperationRecord .dispatch-expand-item strong {
  display: block;
  color: #1f344d;
  font-size: 14px;
  font-weight: 700;
  word-break: break-all;
}

.billOperationRecord .dispatch-route-cell {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 2px;
}

.billOperationRecord .dispatch-route-cell::before {
  content: '';
  position: absolute;
  left: 12px;
  top: 23px;
  bottom: 23px;
  width: 1px;
  background: #cbdff3;
}

.billOperationRecord .dispatch-route-point {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  color: #263c54;
}

.billOperationRecord .dispatch-route-point span {
  position: relative;
  z-index: 1;
  flex: 0 0 24px;
  height: 24px;
  border-radius: 50%;
  background: #e8f4ff;
  color: #1677d2;
  font-size: 12px;
  font-weight: 800;
  line-height: 24px;
  text-align: center;
}

.billOperationRecord .dispatch-route-point-end span {
  background: #fff3e3;
  color: #d8871c;
}

.billOperationRecord .dispatch-route-text {
  flex: 1;
  min-width: 0;
}

.billOperationRecord .dispatch-route-text strong {
  display: block;
  color: #1f344d;
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  word-break: break-all;
}

.billOperationRecord .dispatch-route-text p {
  margin: 3px 0 0;
  color: #7b8fa4;
  font-size: 12px;
  line-height: 18px;
  word-break: break-all;
}

.billOperationRecord .dispatch-amount-cell {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.billOperationRecord .dispatch-amount-cell .dispatch-amount-block {
  padding: 9px 8px;
  border: 1px solid #e4eef8;
  border-radius: 9px;
  background: #f7fbff;
}

.billOperationRecord .dispatch-amount-cell .dispatch-amount-block-highlight {
  background: linear-gradient(135deg, #fffaf0, #fff4df);
  border-color: #ffe2ad;
}

.billOperationRecord .dispatch-amount-cell span {
  display: block;
  margin-bottom: 5px;
  color: #7a8da0;
  font-size: 12px;
}

.billOperationRecord .dispatch-amount-cell strong {
  display: block;
  color: #1e334a;
  font-size: 14px;
  font-weight: 800;
}

.billOperationRecord .dispatch-status-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 7px;
  padding: 2px 0;
}

.billOperationRecord .dispatch-status-stack .dispatch-cell-sub-card:first-child {
  border-color: #b7dcff;
  background: #edf7ff;
  color: #1769b4;
  font-weight: 700;
}

.billOperationRecord .dispatch-status-icons {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.billOperationRecord .dispatch-status-icons .imgStatistics {
  width: 28px;
  height: 28px;
}

.billOperationRecord .dispatch-cell-sub-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.billOperationRecord .dispatch-cell-sub-card {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  min-height: 28px;
  max-width: 100%;
  padding: 4px 10px;
  border: 1px solid #dceafb;
  border-radius: 8px;
  background: #f5f9ff;
  box-sizing: border-box;
}

.billOperationRecord .dispatch-type-cell {
  display: flex;
  justify-content: center;
  align-items: center;
}

.billOperationRecord .dispatch-table-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.billOperationRecord .dispatch-table-actions .el-button {
  margin-left: 0;
}

.billOperationRecord .dispatch-time-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  width: 100%;
  min-width: 0;
  padding-left: 10px;
}

.billOperationRecord .dispatch-time-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  bottom: 3px;
  width: 3px;
  border-radius: 3px;
  background: linear-gradient(180deg, #1890ff, #6bbcff);
}

.billOperationRecord .dispatch-time-kicker {
  display: block;
  color: #9aaabd;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
}

.billOperationRecord .dispatch-time-card strong {
  display: block;
  width: 100%;
  color: #1f344d;
  font-size: 13px;
  font-weight: 800;
  line-height: 20px;
  white-space: nowrap;
}

.billOperationRecord .dispatch-time-code {
  display: block;
  width: 100%;
  color: #7b8fa4;
  font-size: 12px;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.billOperationRecord /deep/ .freight-ux-table .el-table__row {
  cursor: pointer;
  transition: background-color 0.18s ease;
}

.billOperationRecord /deep/ .freight-ux-table .el-table__row:active > td {
  background-color: #edf7ff !important;
}

.billOperationRecord /deep/ .freight-ux-table .el-table__row:hover .freight-main-card,
.billOperationRecord /deep/ .freight-ux-table .el-table__row:hover .freight-info-list,
.billOperationRecord /deep/ .freight-ux-table .el-table__row:hover .dispatch-amount-cell-premium,
.billOperationRecord /deep/ .freight-ux-table .el-table__row:hover .dispatch-status-card-stack {
  border-color: #b8d8f5;
  box-shadow: 0 8px 18px rgba(35, 88, 137, 0.08);
}

.billOperationRecord /deep/ .freight-ux-table .el-table__expand-icon {
  color: #1677d2;
}

.billOperationRecord /deep/ .freight-ux-table .el-table__empty-text {
  color: #7b8fa4;
  font-size: 14px;
}

.billOperationRecord .freight-expand-header {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e8f4ff;
  color: #1677d2;
  font-size: 12px;
  font-weight: 800;
  cursor: help;
}

.billOperationRecord .freight-main-card,
.billOperationRecord .freight-info-list,
.billOperationRecord .dispatch-amount-cell-premium,
.billOperationRecord .dispatch-status-card-stack {
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.billOperationRecord .freight-main-card {
  padding: 10px 12px;
  border: 1px solid #dbe8f5;
  border-radius: 12px;
  background: #fff;
  box-shadow: inset 3px 0 0 #1890ff;
}

.billOperationRecord .freight-main-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #edf3f9;
}

.billOperationRecord .freight-main-head span {
  color: #8a9bad;
  font-size: 12px;
}

.billOperationRecord .freight-main-head strong {
  min-width: 0;
  color: #132f4b;
  font-size: 17px;
  font-weight: 900;
  line-height: 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.billOperationRecord .freight-route-list {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.billOperationRecord .freight-route-list::before {
  content: '';
  position: absolute;
  left: 11px;
  top: 22px;
  bottom: 22px;
  width: 1px;
  background: #d5e6f5;
}

.billOperationRecord .freight-route-row {
  position: relative;
  display: grid;
  grid-template-columns: 24px minmax(0, 1fr);
  align-items: start;
  gap: 8px;
}

.billOperationRecord .freight-route-mark {
  position: relative;
  z-index: 1;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 800;
  line-height: 24px;
  text-align: center;
}

.billOperationRecord .freight-route-mark-load {
  background: #e8f4ff;
  color: #1677d2;
}

.billOperationRecord .freight-route-mark-unload {
  background: #fff3e3;
  color: #d8871c;
}

.billOperationRecord .freight-route-row p {
  margin: 2px 0 0;
  color: #253d56;
  font-size: 13px;
  font-weight: 700;
  line-height: 19px;
  word-break: break-all;
}

.billOperationRecord .freight-info-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 12px;
  border: 1px solid #e2edf8;
  border-radius: 12px;
  background: #fff;
}

.billOperationRecord .freight-info-row {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  align-items: start;
  gap: 9px;
  min-height: 24px;
}

.billOperationRecord .freight-info-row span {
  color: #8a9bad;
  font-size: 12px;
  line-height: 20px;
}

.billOperationRecord .freight-info-row strong,
.billOperationRecord .freight-info-row p {
  margin: 0;
  color: #263c54;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  word-break: break-all;
}

.billOperationRecord .freight-info-row-primary {
  padding-bottom: 8px;
  border-bottom: 1px solid #edf3f9;
}

.billOperationRecord .freight-info-row-primary strong {
  color: #132f4b;
  font-size: 15px;
  font-weight: 900;
}

.billOperationRecord .freight-info-list-people .freight-info-row {
  grid-template-columns: 48px minmax(0, 1fr);
}

.billOperationRecord .dispatch-amount-cell-premium {
  padding: 8px;
  border: 1px solid #e2edf8;
  border-radius: 12px;
  background: #fff;
}

.billOperationRecord .dispatch-amount-cell-premium .dispatch-amount-block {
  min-height: 54px;
  border-radius: 9px;
  background: #f8fbff;
  box-shadow: none;
}

.billOperationRecord .dispatch-amount-cell-premium .dispatch-amount-block-highlight {
  border-color: #ffe2ad;
  background: #fff8ef;
  box-shadow: none;
}

.billOperationRecord .dispatch-amount-cell span {
  color: #8a9bad;
  font-size: 12px;
}

.billOperationRecord .dispatch-amount-cell strong {
  color: #1a334f;
  font-size: 14px;
  font-weight: 900;
}

.billOperationRecord .dispatch-status-card-stack {
  align-items: stretch;
  gap: 7px;
  padding: 8px;
  border: 1px solid #e2edf8;
  border-radius: 12px;
  background: #fff;
}

.billOperationRecord .dispatch-status-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #e2edf8;
  border-radius: 8px;
  background: #f9fcff;
  box-sizing: border-box;
}

.billOperationRecord .dispatch-status-line span {
  flex-shrink: 0;
  color: #7b8fa4;
  font-size: 12px;
}

.billOperationRecord .dispatch-status-line strong {
  min-width: 0;
  color: #1f344d;
  font-size: 13px;
  font-weight: 800;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.billOperationRecord .dispatch-status-line-primary {
  border-color: #b9dcff;
  background: #edf7ff;
}

.billOperationRecord .dispatch-status-line-source {
  border-color: #ffe3bb;
  background: #fff8ef;
}

.billOperationRecord .dispatch-more-btn {
  min-width: 64px;
}

.billOperationRecord .dispatch-more-btn:hover {
  filter: brightness(1.04);
}

.dispatch-action-menu .el-dropdown-menu__item {
  min-width: 118px;
  font-size: 13px;
}

.billOperationRecord .dispatch-source-cell {
  display: flex;
  justify-content: center;
}

.billOperationRecord .pulbic_pagesize {
  display: flex;
  justify-content: flex-end;
  padding: 14px 0 18px;
}

.billOperationRecord /deep/ .el-dialog {
  border-radius: 14px;
  overflow: hidden;
}

.billOperationRecord /deep/ .el-dialog .el-dialog__header {
  padding: 18px 24px;
  border-bottom: 1px solid rgba(220, 230, 240, 0.9);
  background: #f8fbff;
}

.billOperationRecord /deep/ .el-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
}

.billOperationRecord /deep/ .el-dialog .el-dialog__body {
  padding: 20px 24px 24px;
}

.billOperationRecord /deep/ .freight-detail-dialog {
  max-width: 1320px;
}

.billOperationRecord /deep/ .freight-detail-dialog .el-dialog__header {
  padding: 12px 18px;
}

.billOperationRecord /deep/ .freight-detail-dialog .el-dialog__body {
  padding: 12px 16px 14px;
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-intro {
  margin-bottom: 8px;
  padding: 8px 12px;
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-intro-desc {
  margin-top: 3px;
  line-height: 18px;
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-footer {
  margin-top: 10px;
}

.freight-detail-shell {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.freight-detail-summary {
  display: grid;
  grid-template-columns: minmax(220px, 0.9fr) minmax(0, 2.1fr);
  gap: 8px;
  padding: 8px;
  border: 1px solid rgba(196, 216, 235, 0.9);
  border-radius: 10px;
  background:
    radial-gradient(circle at 0 0, rgba(8, 214, 145, 0.1), transparent 160px),
    linear-gradient(135deg, #f7fbff 0%, #ffffff 100%);
}

.freight-detail-summary-main,
.freight-detail-summary-grid > div,
.freight-detail-board-left,
.freight-detail-board-top,
.freight-detail-board-bottom {
  border: 1px solid #e1edf8;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
}

.freight-detail-summary-main {
  min-width: 0;
  padding: 8px 10px;
}

.freight-detail-hero-label,
.freight-detail-summary-grid span {
  display: block;
  color: #7a8da0;
  font-size: 12px;
  line-height: 16px;
}

.freight-detail-summary-main strong {
  display: block;
  margin-top: 4px;
  color: #163250;
  font-size: 18px;
  font-weight: 900;
  line-height: 24px;
  word-break: break-all;
}

.freight-detail-summary-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.freight-detail-summary-grid > div {
  min-width: 0;
  padding: 7px 9px;
}

.freight-detail-summary-grid strong {
  display: block;
  margin-top: 3px;
  color: #263c54;
  font-size: 13px;
  font-weight: 800;
  line-height: 18px;
  word-break: break-all;
}

.freight-detail-board {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(520px, 0.92fr);
  gap: 10px;
  align-items: start;
}

.freight-detail-board-left,
.freight-detail-board-top,
.freight-detail-board-bottom {
  min-width: 0;
  padding: 9px 10px 10px;
}

.freight-detail-board-right {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
  min-width: 0;
}

.freight-detail-board .dispatch-dialog-block-title {
  margin: 0 0 7px;
  padding-left: 8px;
  border-left: 3px solid #199fff;
  font-size: 14px;
  line-height: 16px;
}

.freight-detail-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 6px 8px;
}

.freight-detail-info-grid .DWD-li {
  float: none;
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr);
  align-items: center;
  width: auto;
  min-width: 0;
  min-height: 40px;
  margin: 0;
  padding: 6px 8px;
  border: 1px solid #edf3f9;
  border-radius: 8px;
  background: #f9fcff;
  box-sizing: border-box;
}

.freight-detail-info-grid .DWD-li-title {
  width: auto;
  margin: 0;
  color: #7a8da0;
  font-size: 12px;
  line-height: 16px;
  text-align: left;
}

.freight-detail-info-grid .DWD-li-text {
  width: auto;
  color: #253d56;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  word-break: break-all;
}

.freight-detail-compare {
  min-width: 0;
  padding: 8px;
  border: 1px solid #d5e7f9;
  border-radius: 12px;
  background: linear-gradient(180deg, #f7fbff 0%, #ffffff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.freight-detail-compare-tight .dispatch-dialog-table {
  display: block;
  width: 100%;
  overflow-x: hidden;
  border: none;
  border-radius: 10px;
  background: transparent;
}

.freight-detail-compare-tight .DWD-table-left-title,
.freight-detail-compare-tight .DWD-table-left-flex {
  display: grid;
  grid-template-columns: 90px repeat(3, minmax(0, 1fr));
  min-width: 0;
  min-height: 50px;
  margin-top: 6px;
  border: 1px solid #e2eef9;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.freight-detail-compare-tight .DWD-table-left-title {
  min-height: 44px;
  margin-top: 0;
  border-color: #cfe5fb;
  box-shadow: 0 6px 14px rgba(31, 115, 184, 0.08);
}

.freight-detail-compare-tight .DWD-table-left-title > div,
.freight-detail-compare-tight .DWD-table-left-flex > div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 0;
  min-height: 50px;
  padding: 10px 8px;
  overflow: visible;
  border-right: 1px solid #e8f0f8;
  border-bottom: none;
  box-sizing: border-box;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  word-break: break-all;
}

.freight-detail-compare-tight .DWD-table-left-title > div:last-child,
.freight-detail-compare-tight .DWD-table-left-flex > div:last-child {
  border-right: none;
}

.freight-detail-compare-tight .DWD-table-left-title > div {
  min-height: 44px;
  background: linear-gradient(135deg, #eaf6ff 0%, #f7fcff 100%);
  color: #214a70;
  font-weight: 800;
}

.freight-detail-compare-tight .DWD-table-left-title > div:not(:first-child) {
  color: #0f7fc4;
}

.freight-detail-compare-tight .DWD-table-left-flex > div:first-child {
  justify-content: flex-start;
  background: #f7fbff;
  color: #4f6278;
  font-weight: 800;
}

.freight-detail-compare-tight .DWD-table-left-flex > div:not(:first-child) {
  color: #263f58;
  font-weight: 700;
}

.freight-detail-compare-tight .DWD-table-left-flex:nth-child(even) {
  background: #fbfdff;
}

.freight-detail-image-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.freight-detail-figure-compact {
  min-height: 84px;
  margin-top: 0;
  padding: 8px 10px;
}

.freight-detail-figure-compact .DetailsWater-img-text {
  min-width: 64px;
  font-size: 12px;
}


.dispatch-dialog-intro {
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.1), rgba(24, 144, 255, 0.04));
}

.dispatch-dialog-intro-title {
  font-size: 15px;
  font-weight: 600;
  color: #244868;
}

.dispatch-dialog-intro-desc {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.6;
  color: #5f7288;
}

.dispatch-detail-grid {
  margin-bottom: 16px;
}

.dispatch-dialog-block-title {
  margin: 18px 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: #244868;
}

.dispatch-dialog-table {
  overflow-x: auto;
}

.dispatch-dialog-figure {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  padding: 14px 16px;
  border: 1px solid rgba(196, 214, 232, 0.9);
  border-radius: 10px;
  background: #f8fbff;
}

.dispatch-dialog-figure .DetailsWater-img-text {
  width: auto;
  min-width: 72px;
  text-align: left;
  font-weight: 600;
  color: #4f6278;
}

.dispatch-dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}


.billOperationRecord /deep/ .freight-detail-dialog {
  max-width: 1380px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 18px 48px rgba(20, 58, 96, 0.2);
}

.billOperationRecord /deep/ .freight-detail-dialog .el-dialog__header {
  padding: 16px 22px;
  border-bottom: 1px solid #e6f0fa;
  background: linear-gradient(135deg, #f3f9ff 0%, #ffffff 62%, #eef8ff 100%);
}

.billOperationRecord /deep/ .freight-detail-dialog .el-dialog__title {
  color: #173a5e;
  font-size: 17px;
  font-weight: 800;
}

.billOperationRecord /deep/ .freight-detail-dialog .el-dialog__body {
  padding: 16px 18px 16px;
  background: linear-gradient(180deg, #f5f9fd 0%, #ffffff 38%);
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-intro {
  margin-bottom: 12px;
  padding: 12px 16px;
  border: 1px solid #d8ebfb;
  border-radius: 14px;
  background:
    radial-gradient(circle at 24px 10px, rgba(25, 159, 255, 0.14), transparent 150px),
    linear-gradient(135deg, #f7fbff 0%, #ffffff 100%);
  box-shadow: 0 8px 20px rgba(31, 115, 184, 0.06);
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-intro-title {
  color: #173a5e;
  font-size: 16px;
  font-weight: 900;
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-intro-desc {
  margin-top: 5px;
  color: #60768c;
  font-size: 13px;
  line-height: 20px;
}

.freight-detail-shell {
  gap: 12px;
}

.freight-detail-summary {
  grid-template-columns: minmax(250px, 0.85fr) minmax(0, 2.15fr);
  gap: 10px;
  padding: 10px;
  border: 1px solid #d7e9fa;
  border-radius: 16px;
  background:
    radial-gradient(circle at 0 0, rgba(25, 159, 255, 0.16), transparent 220px),
    linear-gradient(135deg, #f8fcff 0%, #ffffff 100%);
  box-shadow: 0 10px 28px rgba(31, 115, 184, 0.08);
}

.freight-detail-summary-main,
.freight-detail-summary-grid > div,
.freight-detail-board-left,
.freight-detail-board-top,
.freight-detail-board-bottom {
  border: 1px solid #dfeefa;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 22px rgba(31, 115, 184, 0.06);
}

.freight-detail-summary-main {
  padding: 12px 14px;
  background:
    linear-gradient(135deg, rgba(25, 159, 255, 0.1), rgba(8, 214, 145, 0.06)),
    #fff;
}

.freight-detail-hero-label,
.freight-detail-summary-grid span {
  color: #7b90a5;
  font-size: 12px;
  font-weight: 600;
}

.freight-detail-summary-main strong {
  margin-top: 7px;
  color: #12375c;
  font-size: 20px;
  line-height: 28px;
}

.freight-detail-summary-grid {
  gap: 10px;
}

.freight-detail-summary-grid > div {
  padding: 10px 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.freight-detail-summary-grid strong {
  margin-top: 6px;
  color: #1e3f62;
  font-size: 14px;
  line-height: 20px;
}

.freight-detail-board {
  grid-template-columns: minmax(0, 1.04fr) minmax(540px, 0.96fr);
  gap: 12px;
}

.freight-detail-board-left,
.freight-detail-board-top,
.freight-detail-board-bottom {
  padding: 12px;
}

.freight-detail-board .dispatch-dialog-block-title {
  display: flex;
  align-items: center;
  margin: 0 0 10px;
  padding-left: 10px;
  border-left: 4px solid #199fff;
  color: #173a5e;
  font-size: 15px;
  font-weight: 900;
  line-height: 20px;
}

.freight-detail-info-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px 8px;
}

.freight-detail-info-grid .DWD-li {
  grid-template-columns: 118px minmax(0, 1fr);
  min-height: 46px;
  padding: 8px 10px;
  border-color: #e5f0fa;
  border-radius: 10px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fcff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.freight-detail-info-grid .DWD-li-title {
  color: #7b90a5;
  font-weight: 600;
}

.freight-detail-info-grid .DWD-li-text {
  color: #203d5b;
  font-size: 13px;
  font-weight: 800;
  line-height: 19px;
}

.freight-detail-image-grid {
  gap: 10px;
}

.freight-detail-figure-compact {
  min-height: 96px;
  padding: 12px 14px;
  border-color: #dceafb;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f7fbff 100%);
}

.freight-detail-figure-compact .DetailsWater-img-text {
  min-width: 70px;
  color: #385775;
  font-weight: 800;
}

.billOperationRecord /deep/ .freight-detail-dialog .el-image {
  border-radius: 10px;
  box-shadow: 0 8px 18px rgba(31, 115, 184, 0.12);
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-footer {
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid #edf3f9;
}


.freight-detail-summary {
  position: relative;
  overflow: hidden;
}

.freight-detail-summary::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #199fff 0%, #08d691 100%);
}

.freight-detail-summary-main {
  border-color: #cde8fb;
}

.freight-detail-summary-grid > div {
  border-color: #e6f0fa;
}

.freight-detail-summary-grid > div::before {
  content: '';
  display: block;
  width: 24px;
  height: 3px;
  margin-bottom: 7px;
  border-radius: 999px;
  background: #199fff;
  opacity: 0.55;
}

.freight-detail-board-left,
.freight-detail-board-top,
.freight-detail-board-bottom {
  overflow: hidden;
}

.freight-detail-board-left {
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
}

.freight-detail-board-top {
  border-color: #cfe5fb;
  background: linear-gradient(180deg, #f8fcff 0%, #ffffff 100%);
}

.freight-detail-board-bottom {
  border-color: #d8efe8;
  background: linear-gradient(180deg, #f8fffc 0%, #ffffff 100%);
}

.freight-detail-board .dispatch-dialog-block-title {
  margin: -12px -12px 12px;
  padding: 12px 14px 12px 18px;
  border-left: none;
  border-bottom: 1px solid #e4eff9;
  background: linear-gradient(135deg, #eef8ff 0%, #ffffff 100%);
}

.freight-detail-board .dispatch-dialog-block-title::before {
  content: '';
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background: #199fff;
  box-shadow: 0 0 0 4px rgba(25, 159, 255, 0.12);
}

.freight-detail-board-bottom .dispatch-dialog-block-title {
  background: linear-gradient(135deg, #eefbf6 0%, #ffffff 100%);
}

.freight-detail-board-bottom .dispatch-dialog-block-title::before {
  background: #08b985;
  box-shadow: 0 0 0 4px rgba(8, 185, 133, 0.12);
}

.freight-detail-info-grid .DWD-li {
  position: relative;
  align-items: flex-start;
  border-color: #e7f0f8;
}

.freight-detail-info-grid .DWD-li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 0 999px 999px 0;
  background: #b9dcf8;
}

.freight-detail-info-grid .DWD-li-title {
  padding-top: 1px;
}

.freight-detail-info-grid .DWD-li-text {
  min-height: 20px;
  padding: 2px 8px;
  border-radius: 6px;
  background: #f4f9fe;
}

.freight-detail-compare {
  border-width: 2px;
}

.freight-detail-compare-tight .DWD-table-left-title {
  position: relative;
}

.freight-detail-compare-tight .DWD-table-left-flex {
  box-shadow: 0 4px 12px rgba(31, 115, 184, 0.04);
}

.freight-detail-compare-tight .DWD-table-left-flex > div:first-child {
  color: #214a70;
}

.freight-detail-figure-compact {
  box-shadow: 0 6px 18px rgba(8, 185, 133, 0.07);
}

.billOperationRecord /deep/ .freight-detail-dialog .el-dialog__title {
  font-size: 19px;
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-intro-title {
  font-size: 18px;
  line-height: 24px;
}

.billOperationRecord /deep/ .freight-detail-dialog .dispatch-dialog-intro-desc {
  font-size: 14px;
  line-height: 22px;
}

.freight-detail-hero-label,
.freight-detail-summary-grid span {
  font-size: 14px;
  line-height: 20px;
}

.freight-detail-summary-main strong {
  font-size: 22px;
  line-height: 30px;
}

.freight-detail-summary-grid strong {
  font-size: 16px;
  line-height: 23px;
}

.freight-detail-board .dispatch-dialog-block-title {
  font-size: 17px;
  line-height: 24px;
}

.freight-detail-info-grid .DWD-li-title {
  font-size: 14px;
  line-height: 21px;
}

.freight-detail-info-grid .DWD-li-text {
  font-size: 15px;
  line-height: 22px;
}

.freight-detail-compare-tight .DWD-table-left-title > div,
.freight-detail-compare-tight .DWD-table-left-flex > div {
  font-size: 14px;
  line-height: 22px;
}

.freight-detail-figure-compact .DetailsWater-img-text {
  font-size: 15px;
  line-height: 22px;
}

.factory-complete-dialog {
  max-width: 760px;
  border-radius: 22px;
  overflow: hidden;
  box-shadow: 0 24px 70px rgba(22, 51, 82, 0.16);
}

.factory-complete-dialog .el-dialog__header {
  padding: 18px 24px 14px;
  border-bottom: 0;
  background:
    radial-gradient(circle at 14% 0, rgba(25, 159, 255, 0.16), transparent 210px),
    radial-gradient(circle at 86% 0, rgba(8, 185, 133, 0.12), transparent 220px),
    linear-gradient(135deg, #f7fbff 0%, #ffffff 100%);
}

.factory-complete-dialog .el-dialog__title {
  color: #12375c;
  font-size: 19px;
  font-weight: 900;
  letter-spacing: 0.02em;
}

.factory-complete-dialog .el-dialog__body {
  max-height: calc(100vh - 150px);
  padding: 0 20px 18px;
  overflow-y: auto;
  background:
    radial-gradient(circle at 100% 22%, rgba(8, 185, 133, 0.08), transparent 250px),
    linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.factory-complete-intro {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 14px;
  padding: 14px 12px 2px;
}

.factory-complete-summary-card span,
.factory-complete-section-title em {
  display: block;
  color: #7890a6;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.factory-complete-shell {
  display: grid;
  gap: 12px;
}

.factory-complete-guide {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 12px;
}

.factory-complete-guide span {
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 10px;
  border: 1px solid rgba(25, 159, 255, 0.14);
  border-radius: 999px;
  background: rgba(239, 248, 255, 0.68);
  color: #5f7890;
  font-size: 12px;
  font-weight: 800;
}

.factory-complete-guide span.is-done {
  border-color: rgba(8, 185, 133, 0.2);
  background: rgba(233, 251, 243, 0.86);
  color: #08a676;
}

.factory-complete-guide span.is-optional {
  border-color: rgba(144, 164, 184, 0.24);
  background: rgba(246, 248, 250, 0.88);
  color: #6f8194;
}

.factory-complete-progress {
  display: grid;
  grid-template-columns: 118px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 0 12px;
}

.factory-complete-progress-info {
  display: flex;
  align-items: baseline;
  gap: 6px;
  color: #6f8194;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.factory-complete-progress-info strong {
  color: #173a5e;
  font-size: 15px;
  font-weight: 900;
}

.factory-complete-progress-track {
  height: 8px;
  overflow: hidden;
  border-radius: 999px;
  background: #e8f1f9;
}

.factory-complete-progress-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #199fff 0%, #08b985 100%);
  box-shadow: 0 4px 12px rgba(25, 159, 255, 0.2);
  transition: width 0.25s ease;
}

.factory-complete-summary {
  display: grid;
  grid-template-columns: 1.2fr repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.factory-complete-summary-card,
.factory-complete-section,
.factory-complete-upload-card {
  border: 1px solid rgba(218, 232, 244, 0.9);
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.86);
  box-shadow: 0 12px 34px rgba(31, 115, 184, 0.055);
}

.factory-complete-summary-card,
.factory-complete-upload-card {
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease, background 0.2s ease;
}

.factory-complete-summary-card:hover,
.factory-complete-upload-card:hover {
  border-color: rgba(25, 159, 255, 0.34);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 16px 34px rgba(31, 115, 184, 0.1);
  transform: translateY(-1px);
}

.factory-complete-summary-card {
  min-width: 0;
  padding: 11px 12px;
  overflow: hidden;
}

.factory-complete-summary-card-main {
  border-color: rgba(25, 159, 255, 0.24);
  background: linear-gradient(135deg, rgba(239, 248, 255, 0.9) 0%, rgba(255, 255, 255, 0.92) 100%);
}

.factory-complete-summary-card strong {
  display: block;
  margin-top: 6px;
  color: #173a5e;
  font-size: 15px;
  font-weight: 900;
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.factory-complete-section {
  padding: 13px;
}

.factory-complete-section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 11px;
  padding-bottom: 9px;
  border-bottom: 1px solid rgba(237, 244, 251, 0.9);
}

.factory-complete-section-title span {
  display: inline-flex;
  align-items: center;
  color: #163b5e;
  font-size: 15px;
  font-weight: 900;
  line-height: 22px;
}

.factory-complete-section-title span::before {
  content: '';
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background: #199fff;
  box-shadow: 0 0 0 4px rgba(25, 159, 255, 0.12);
}

.factory-complete-section-title-upload span::before {
  background: #08b985;
  box-shadow: 0 0 0 4px rgba(8, 185, 133, 0.12);
}

.factory-complete-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  padding: 0;
  border: 0;
  background: transparent;
  box-shadow: none;
}

.factory-complete-form .CustomerfillingDig-tab-li {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) 58px;
  align-items: center;
  column-gap: 10px;
  min-height: 54px;
  padding: 9px 11px;
  border: 1px solid rgba(224, 236, 246, 0.95);
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 8px 22px rgba(31, 115, 184, 0.04);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease, background 0.2s ease;
}

.factory-complete-form .CustomerfillingDig-tab-li:hover,
.factory-complete-form .CustomerfillingDig-tab-li:focus-within {
  border-color: rgba(25, 159, 255, 0.36);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 28px rgba(25, 159, 255, 0.09);
  transform: translateY(-1px);
}

.factory-complete-form .factory-complete-field-wide {
  grid-column: 1 / -1;
}

.factory-complete-form .factory-complete-required {
  border-color: rgba(25, 159, 255, 0.25);
  background: rgba(247, 251, 255, 0.78);
}

.factory-complete-form .factory-complete-amount {
  border-color: rgba(8, 185, 133, 0.22);
  background: rgba(246, 255, 251, 0.8);
}

.factory-complete-form .CustomerfillingDig-tab-li-text {
  grid-column: 1;
  padding: 0;
  border: 0;
  background: transparent !important;
  color: #5f7890;
  font-size: 13px;
  font-weight: 800;
  line-height: 18px;
  white-space: nowrap;
}

.factory-required-mark {
  margin-left: 3px;
  color: #f56c6c;
  font-weight: 900;
}

.factory-field-unit {
  margin-left: 5px;
  color: #90a4b8;
  font-size: 12px;
  font-weight: 700;
}

.factory-complete-assist {
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 12px;
  background: rgba(239, 248, 255, 0.7);
  color: #6f8194;
  font-size: 12px;
  line-height: 18px;
}

.factory-complete-form .CustomerfillingDig-tab-li-ipt {
  grid-column: 2;
  min-width: 0;
}

.factory-complete-form .CustomerfillingDig-tab-li-b {
  grid-column: 3;
  justify-self: end;
  padding: 2px 8px;
  border-radius: 999px;
  background: #eef6ff;
  color: #3781bd;
  font-size: 12px;
  font-weight: 800;
  line-height: 18px;
  white-space: nowrap;
  transition: color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.factory-complete-form .CustomerfillingDig-tab-li-b.is-done {
  background: #e9fbf3;
  color: #08a676;
  box-shadow: 0 0 0 3px rgba(8, 185, 133, 0.08);
}

.factory-complete-form .CustomerfillingDig-tab-li:focus-within .CustomerfillingDig-tab-li-b {
  background: #e8f4ff;
  color: #1598ef;
}

.factory-complete-form .factory-complete-required .CustomerfillingDig-tab-li-b {
  background: #fff1f0;
  color: #f56c6c;
}

.factory-complete-form .factory-complete-amount .CustomerfillingDig-tab-li-b {
  background: #e9fbf3;
  color: #08a676;
}

.factory-complete-form .CustomerfillingDig-tab-li-ipt input {
  width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid rgba(217, 230, 242, 0.95);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.95);
  color: #183a5c;
  font-size: 14px;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}

.factory-complete-form .CustomerfillingDig-tab-li-ipt input:disabled {
  border-color: #d8e0e8;
  background: #f1f5f9;
  color: #60758a;
  cursor: not-allowed;
}

.factory-complete-form .CustomerfillingDig-tab-li-ipt input:focus {
  border-color: #199fff;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
  outline: none;
}

.factory-complete-form /deep/ .el-input__inner:focus {
  border-color: #199fff;
  box-shadow: 0 0 0 3px rgba(25, 159, 255, 0.12);
}

.factory-complete-form .CustomerfillingDig-tab-li-ipt .el-select,
.factory-complete-form .factory-complete-select-wrap {
  width: 100%;
}

.factory-complete-form input::placeholder {
  color: #a4b5c6;
}

.factory-complete-upload-section {
  border-style: dashed;
  border-color: rgba(139, 190, 229, 0.48);
  background: rgba(249, 252, 255, 0.72);
}

.factory-complete-upload-card {
  padding: 13px;
  border-style: dashed;
  background:
    radial-gradient(circle at 0 0, rgba(8, 185, 133, 0.07), transparent 190px),
    rgba(255, 255, 255, 0.86);
}

.factory-complete-upload-card.is-done {
  border-color: rgba(8, 185, 133, 0.36);
  background:
    radial-gradient(circle at 0 0, rgba(8, 185, 133, 0.11), transparent 190px),
    rgba(248, 255, 252, 0.94);
}

.factory-complete-upload-tip {
  display: grid;
  gap: 3px;
  margin-bottom: 10px;
  color: #6f8194;
  font-size: 12px;
  line-height: 18px;
}

.factory-complete-upload-tip em {
  color: #90a4b8;
  font-style: normal;
}

.factory-complete-upload-card .el-upload {
  display: flex;
  align-items: center;
  gap: 10px;
}

.factory-complete-upload-card .el-button,
.factory-complete-footer .el-button {
  min-width: 120px;
  border-radius: 9px;
  transition: box-shadow 0.2s ease, transform 0.2s ease, opacity 0.2s ease;
}

.factory-complete-upload-card .el-button:hover,
.factory-complete-footer .el-button:hover {
  transform: translateY(-1px);
}

.factory-upload-btn {
  border-color: #08b985;
  background: linear-gradient(135deg, #08b985 0%, #1598ef 100%);
  box-shadow: 0 10px 20px rgba(8, 185, 133, 0.16);
}

.factory-upload-btn i {
  margin-right: 5px;
  font-size: 14px;
}

.factory-upload-btn:hover,
.factory-upload-btn:focus {
  border-color: #08a676;
  box-shadow: 0 12px 24px rgba(8, 185, 133, 0.24);
  opacity: 0.95;
}

.factory-complete-upload-card .el-upload-list__item {
  margin-top: 10px;
}

.factory-complete-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid rgba(237, 244, 251, 0.9);
}

.factory-complete-submit-tip {
  position: relative;
  padding-left: 18px;
  color: #6f8194;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
}

.factory-complete-submit-tip::before {
  content: '';
  position: absolute;
  left: 0;
  top: 6px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #08b985;
  box-shadow: 0 0 0 4px rgba(8, 185, 133, 0.12);
}

.factory-complete-submit-tip.is-ready {
  color: #08a676;
}

.factory-complete-submit-tip.is-ready::before {
  background: #08b985;
  box-shadow: 0 0 0 4px rgba(8, 185, 133, 0.16);
}

.factory-complete-footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  flex-shrink: 0;
}

.factory-complete-footer .el-button {
  min-width: 108px;
  border-radius: 10px;
}

.factory-complete-footer .el-button--primary {
  border-color: #1598ef;
  background: linear-gradient(135deg, #1598ef 0%, #08b985 100%);
  box-shadow: 0 10px 22px rgba(25, 159, 255, 0.18);
}

.factory-complete-footer .el-button--primary:hover,
.factory-complete-footer .el-button--primary:focus {
  border-color: #1287d4;
  box-shadow: 0 14px 28px rgba(25, 159, 255, 0.26);
}

@media (max-width: 900px) {
  .factory-complete-summary,
  .factory-complete-form {
    grid-template-columns: 1fr;
  }

  .factory-complete-intro,
  .factory-complete-section-title {
    align-items: flex-start;
    flex-direction: column;
  }

  .factory-complete-guide {
    padding: 0;
  }

  .factory-complete-progress {
    grid-template-columns: 1fr;
    padding: 0;
  }

  .factory-complete-footer {
    align-items: stretch;
    flex-direction: column;
  }

  .factory-complete-footer-actions {
    justify-content: flex-end;
  }
}


.freight-detail-info-grid .DWD-li {
  display: grid;
  grid-template-columns: 128px minmax(0, 1fr);
  align-items: center;
  gap: 8px;
  min-height: 42px;
  height: auto;
  padding: 6px 10px;
}

.freight-detail-info-grid .DWD-li-title {
  width: auto;
  color: #5f7890;
  font-size: 13px;
  line-height: 18px;
  white-space: nowrap;
}

.freight-detail-info-grid .DWD-li-text {
  display: block;
  width: 100%;
  min-height: 24px;
  height: auto;
  padding: 3px 7px;
  overflow: visible;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  word-break: break-all;
}

.billOperationRecord /deep/ .freight-detail-dialog {
  max-width: 1180px;
}

.billOperationRecord /deep/ .freight-detail-dialog .el-dialog__body {
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  padding: 16px 18px 14px;
}

.billOperationRecord /deep/ .freight-detail-dialog .freight-detail-intro {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.freight-detail-shell {
  gap: 12px;
}

.freight-detail-hero {
  display: grid;
  grid-template-columns: minmax(240px, 0.78fr) minmax(0, 2.22fr);
  gap: 12px;
  padding: 12px;
  border: 1px solid #d3e8f9;
  border-radius: 18px;
  background:
    radial-gradient(circle at 0 0, rgba(25, 159, 255, 0.18), transparent 240px),
    radial-gradient(circle at 100% 0, rgba(8, 214, 145, 0.12), transparent 220px),
    linear-gradient(135deg, #f8fcff 0%, #ffffff 100%);
  box-shadow: 0 12px 30px rgba(31, 115, 184, 0.1);
}

.freight-detail-hero-main,
.freight-detail-mini-card,
.freight-detail-route,
.freight-detail-section {
  border: 1px solid #e0edf8;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 8px 22px rgba(31, 115, 184, 0.06);
}

.freight-detail-hero-main {
  position: relative;
  min-width: 0;
  padding: 16px 18px;
  overflow: hidden;
}

.freight-detail-hero-main::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: linear-gradient(180deg, #199fff 0%, #08d691 100%);
}

.freight-detail-eyebrow,
.freight-detail-mini-card span,
.freight-detail-field span,
.freight-detail-note-card span {
  display: block;
  color: #7890a6;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
}

.freight-detail-hero-main strong {
  display: block;
  margin-top: 8px;
  color: #12375c;
  font-size: 24px;
  font-weight: 900;
  line-height: 32px;
  word-break: break-all;
}

.freight-detail-hero-sub {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.freight-detail-hero-sub span {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef7ff;
  color: #4e6c88;
  font-size: 13px;
  font-weight: 700;
}

.freight-detail-hero-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 10px;
}

.freight-detail-mini-card {
  flex: 0 1 max-content;
  min-width: 138px;
  max-width: 260px;
  min-height: 64px;
  padding: 10px 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.freight-detail-mini-card strong {
  display: block;
  margin-top: 7px;
  color: #1d3d5f;
  font-size: 16px;
  font-weight: 900;
  line-height: 23px;
  word-break: break-all;
}

.freight-detail-mini-card-car {
  border-color: #cfe8fb;
  background: linear-gradient(135deg, #eef8ff 0%, #ffffff 100%);
}

.freight-detail-mini-card-car strong {
  color: #0d6fb8;
  font-size: 20px;
}

.freight-detail-route {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 80px minmax(0, 1fr);
  align-items: stretch;
  gap: 12px;
  padding: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #f6fbff 100%);
}

.freight-detail-route-point {
  display: grid;
  grid-template-columns: 38px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  min-width: 0;
}

.freight-detail-route-point > span {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  color: #fff;
  font-size: 15px;
  font-weight: 900;
  line-height: 38px;
  text-align: center;
}

.freight-detail-route-start > span {
  background: linear-gradient(135deg, #199fff, #5cbaff);
}

.freight-detail-route-end > span {
  background: linear-gradient(135deg, #ff8b3d, #ffb368);
}

.freight-detail-route-point em {
  display: block;
  color: #7890a6;
  font-style: normal;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
}

.freight-detail-route-point strong {
  display: block;
  margin-top: 5px;
  color: #183b5c;
  font-size: 16px;
  font-weight: 900;
  line-height: 23px;
  word-break: break-all;
}

.freight-detail-route-line {
  display: flex;
  align-items: center;
  justify-content: center;
}

.freight-detail-route-line span {
  position: relative;
  display: block;
  width: 100%;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, #199fff, #ff9b4b);
}

.freight-detail-route-line span::after {
  content: '';
  position: absolute;
  right: -1px;
  top: 50%;
  width: 8px;
  height: 8px;
  border-top: 2px solid #ff9b4b;
  border-right: 2px solid #ff9b4b;
  transform: translateY(-50%) rotate(45deg);
}

.freight-detail-content {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(430px, 0.82fr);
  gap: 12px;
  align-items: start;
}

.freight-detail-content-main,
.freight-detail-content-side {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  min-width: 0;
}

.freight-detail-section {
  min-width: 0;
  overflow: hidden;
}

.freight-detail-section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 13px 16px;
  border-bottom: 1px solid #e4eff9;
  background: linear-gradient(135deg, #eef8ff 0%, #ffffff 100%);
}

.freight-detail-section-head strong {
  display: flex;
  align-items: center;
  color: #173a5e;
  font-size: 16px;
  font-weight: 900;
  line-height: 22px;
}

.freight-detail-section-head strong::before {
  content: '';
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background: #199fff;
  box-shadow: 0 0 0 4px rgba(25, 159, 255, 0.12);
}

.freight-detail-section-head span {
  color: #7b90a5;
  font-size: 13px;
  line-height: 18px;
  text-align: right;
}

.freight-detail-info-grid,
.freight-detail-note-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 10px;
  padding: 12px;
}

.freight-detail-field,
.freight-detail-note-card {
  flex: 0 1 max-content;
  min-width: 150px;
  max-width: 320px;
  min-height: 58px;
  padding: 9px 10px;
  border: 1px solid #e7f0f8;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f9fcff 100%);
  box-sizing: border-box;
}

.freight-detail-field strong,
.freight-detail-note-card strong {
  display: block;
  margin-top: 7px;
  color: #203d5b;
  font-size: 15px;
  font-weight: 900;
  line-height: 22px;
  word-break: break-all;
}

.freight-detail-field-primary {
  border-color: #cfe7fb;
  background: linear-gradient(135deg, #eef8ff 0%, #ffffff 100%);
}

.freight-detail-field-primary strong {
  color: #0d6fb8;
  font-size: 18px;
}

.freight-detail-field-wide,
.freight-detail-note-card-wide {
  flex-basis: auto;
  min-width: 260px;
  max-width: 100%;
}

.freight-detail-section-note .freight-detail-section-head {
  background: linear-gradient(135deg, #fff8ef 0%, #ffffff 100%);
}

.freight-detail-section-note .freight-detail-section-head strong::before {
  background: #ff9b4b;
  box-shadow: 0 0 0 4px rgba(255, 155, 75, 0.14);
}

.freight-detail-note-card {
  min-height: 64px;
  background: #fffdf9;
}

.freight-detail-section-compare .freight-detail-section-head {
  background: linear-gradient(135deg, #eef8ff 0%, #ffffff 100%);
}

.freight-detail-section-images .freight-detail-section-head {
  background: linear-gradient(135deg, #eefbf6 0%, #ffffff 100%);
}

.freight-detail-section-images .freight-detail-section-head strong::before {
  background: #08b985;
  box-shadow: 0 0 0 4px rgba(8, 185, 133, 0.12);
}

.freight-detail-section .freight-detail-compare {
  margin: 12px;
  padding: 10px;
}

.freight-detail-compare-tight .DWD-table-left-title,
.freight-detail-compare-tight .DWD-table-left-flex {
  grid-template-columns: 82px repeat(3, minmax(0, 1fr));
  min-height: 44px;
}

.freight-detail-compare-tight .DWD-table-left-title > div,
.freight-detail-compare-tight .DWD-table-left-flex > div {
  min-height: 44px;
  padding: 8px 6px;
}

.freight-detail-section-images .freight-detail-image-grid {
  padding: 12px;
}

.freight-detail-figure-compact {
  justify-content: space-between;
  min-height: 112px;
  margin: 0;
}

.freight-detail-figure-compact .DetailsWater-img-text {
  min-width: 74px;
  color: #385775;
  font-size: 15px;
  font-weight: 900;
}

@media screen and (max-width: 1280px) {
  .billOperationRecord .dispatch-section-head {
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .billOperationRecord .dispatch-table-tools {
    width: 100%;
    align-items: flex-start;
    margin-left: 0;
  }

  .billOperationRecord .freight-stat-panel {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .billOperationRecord .freight-stat-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .billOperationRecord .freight-stat-group-title {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }

  .billOperationRecord .freight-stat-group-title em {
    white-space: normal;
  }

  .freight-detail-summary,
  .freight-detail-board,
  .freight-detail-hero,
  .freight-detail-content {
    grid-template-columns: minmax(0, 1fr);
  }

  .freight-detail-summary-grid,
  .freight-detail-hero-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 960px) {
  .billOperationRecord .dispatch-filter-card > .public_criteriaRange {
    grid-template-columns: minmax(0, 1fr);
  }

  .billOperationRecord .dispatch-filter-card > .public_criteriaRange .public_lbSty {
    flex: 0 0 76px;
  }

  .billOperationRecord .dispatch-operat-btn {
    width: 100%;
    margin-left: 0;
  }

  .billOperationRecord .freight-stat-shell {
    padding: 12px;
  }

  .billOperationRecord .freight-stat-panel,
  .billOperationRecord .freight-stat-subgrid,
  .billOperationRecord .freight-stat-subgrid-compact,
  .freight-detail-hero,
  .freight-detail-hero-grid,
  .freight-detail-route,
  .freight-detail-content,
  .freight-detail-info-grid,
  .freight-detail-note-grid,
  .freight-detail-image-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .freight-detail-route-line {
    display: none;
  }

  .freight-detail-field-wide,
  .freight-detail-note-card-wide {
    min-width: 0;
    max-width: none;
    flex-basis: 100%;
  }

  .freight-detail-section {
    padding: 0;
  }
}

.orderBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  height: 28px;
  padding: 0 10px;
  line-height: 1;
  text-align: center;
  color: #fff;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 6px 16px rgba(48, 88, 140, 0.16);
}

.orderBtnType1 {
  background: linear-gradient(135deg, #5bc59b, #43b887);
}

.orderBtnType2 {
  background: linear-gradient(135deg, #f2bc38, #e2a018);
}
.orderBtn1 {
  background: linear-gradient(135deg, #3d8bfd, #1e6fe8);
}
.orderBtn2 {
  background: linear-gradient(135deg, #ff7a7a, #f14d4d);
}
</style>

<style>
.dispatch-dialog {
  border-radius: 14px;
  overflow: hidden;
}

.dispatch-dialog .el-dialog__header {
  padding: 18px 24px;
  border-bottom: 1px solid rgba(220, 230, 240, 0.9);
  background: #f8fbff;
}

.dispatch-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
}

.dispatch-dialog .el-dialog__body {
  padding: 20px 24px 24px;
}

.freight-detail-dialog {
  max-width: 1380px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 18px 48px rgba(20, 58, 96, 0.2);
}

.freight-detail-dialog .el-dialog__header {
  padding: 16px 22px;
  border-bottom: 1px solid #e6f0fa;
  background: linear-gradient(135deg, #f3f9ff 0%, #ffffff 62%, #eef8ff 100%);
}

.freight-detail-dialog .el-dialog__title {
  color: #173a5e;
  font-size: 17px;
  font-weight: 800;
}

.freight-detail-dialog .el-dialog__body {
  padding: 16px 18px 16px;
  background: linear-gradient(180deg, #f5f9fd 0%, #ffffff 38%);
}

.freight-detail-dialog .dispatch-dialog-intro {
  margin-bottom: 12px;
  padding: 12px 16px;
  border: 1px solid #d8ebfb;
  border-radius: 14px;
  background:
    radial-gradient(circle at 24px 10px, rgba(25, 159, 255, 0.14), transparent 150px),
    linear-gradient(135deg, #f7fbff 0%, #ffffff 100%);
  box-shadow: 0 8px 20px rgba(31, 115, 184, 0.06);
}

.freight-detail-dialog .dispatch-dialog-intro-title {
  color: #173a5e;
  font-size: 16px;
  font-weight: 900;
}

.freight-detail-dialog .dispatch-dialog-intro-desc {
  margin-top: 5px;
  color: #60768c;
  font-size: 13px;
  line-height: 20px;
}

.freight-detail-dialog .dispatch-dialog-footer {
  margin-top: 10px;
}
</style>
<style>
.sales-freight-order-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-freight-order-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-freight-order-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-freight-order-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-freight-order-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
